/* eslint-disable */
import {
	useCallback,
	useEffect,
	useMemo,
	useReducer,
	useRef,
	useState,
} from 'react';
import { connect } from 'react-redux';
import { Button, MenuItem, TextField } from '@mui/material';
import {
	useHistory,
	useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import _ from 'lodash';
import { formActions, modalActions } from '../../../Actions';
import assetActions from '../../../Actions/asset.actions';
import { AddNewVendorModal } from '../../../Components/Modals/AddNewVendorModal';
import { POGeneralDetails } from '../../../Components/POGeneralDetails';
import { POTotalContainer } from '../../../Components/POTotalContainer';
import { notificationServices, skuTypeWiseGroupServices, conversionServices } from '../../../Services';
import inventoryAnalyticsServices from '../../../Services/Analytics Services/inventory-analytics.services';
import CreatePurchaseOrderHeader from './CreatePurchaseOrderHeader/CreatePurchaseOrderHeader';
import config, {
	createOrderReducer,
	getStorageKey,
} from './CreatePurchaseOrder.config';
import styles from './CreatePurchaseOrder.module.scss';
import { GenerateStandardPo } from '../../../Components/Modals/GenerateStandardPo';
import { orderTypes, urls } from '../../../Constants';
import { useAuth } from '../../../Components/Auth/Login/auth';
import {
	getStateFromGSTIN,
	getUnitConvertedQuantity,
	getUnitConvertedUnit,
	getHigherUnitAndQuantity,
	inputHelper,
	useQuery,
} from '../../../Helpers';
import productProcessMapServices from '../../../Services/Analytics Services/product-process-map.services';
import assetServices from '../../../Services/AssetServices/asset.services';
import allVendorServices from '../../../Services/Form Services/allvendor.services';
import productCategoryServcies from '../../../Services/Form Services/productCategoryServcies';
import { BackdropLoader } from '../../../Components/Loaders';
import ErrorModal from '../../../Components/Modals/ErroModal/ErrorModal';
import shiftServices from '../../../Services/shift.service';
import { POItemSelection } from '@/Components/POItemSelection';
import { AssetListing } from '@/Pages/Assets';
import { FileUploaderModal } from '@/Components/Modals/FileUploaderModal';
import { AlertModal } from '@/Components/Modals';
import { loadState } from '@/Helpers/persistenceUtils';
import processFlowServices from '@/Services/Analytics Services/process-flow.services';
import useFeatureFlags from '@/Helpers/useFeatureFlags';
import { purchaseRequestServices } from '@/Services/PurchaseRequestServices/PurchaseRequestService';
import { vendorOrganisationServices } from '@/Services/VendorOrganisationServices/vendorOrganisation.services';
import { CustomModal } from '@/Components/Modals/CustomModal';
import { UniversalSelectionTable } from '@/Components/UniversalSelectionTable';
import { useQuery as useReactQuery } from '@tanstack/react-query';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import wastageAction from '@/Actions/wastage.action';
import { Eye, Loader2, Search, FileCheck2, ExternalLink } from 'lucide-react';
import { SelectPicker, DateRangePicker, Loader } from 'rsuite';

const taxPercentage = 18;

const additinalDiv = [1, 4, 7, 9, 2, 3, 8];

const fetchSelectedPrDetailData = async (prId) => {
	try {
		const response = await purchaseRequestServices.fetchPurchaseRequestDetail({
			data: { prId: prId },
		});
		if (response?.statusCode === 200) {
			const prDetail = response?.data;
			return prDetail;
		}
	} catch (error) {
		console.log('Error fetching PR detail:', error);
	}
};

const PRItemsList = ({ pr, productsList }) => {
	const [items, setItems] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchItems = async () => {
			try {
				const prDetail = await fetchSelectedPrDetailData(pr.id);
				const prItems = prDetail?.items || [];
				const formattedItems = [];

				prItems.forEach((prItem) => {
					const foundProduct = productsList.find((p) =>
						p.variants?.some(
							(v) => Number(v.id) === Number(prItem.entityId)
						)
					);
					const foundVariant = foundProduct?.variants?.find(
						(v) => Number(v.id) === Number(prItem.entityId)
					);

					if (foundProduct && foundVariant) {
						let prJsonData = prItem.jsonData;
						if (typeof prJsonData === 'string') {
							try {
								prJsonData = JSON.parse(prJsonData);
							} catch (e) {
								prJsonData = {};
							}
						}
						const availableQty = prJsonData?.availableQty ?? prItem.qty;

						let displayUnit = foundProduct.unit;
						let displayQty = availableQty;
						if (foundProduct.unit === 'gram') {
							displayUnit = 'kg';
							displayQty = availableQty / 1000;
						} else if (
							foundProduct.unit === 'ml' ||
							foundProduct.unit === 'litre'
						) {
							displayUnit = 'ltr';
							displayQty = availableQty / 1000;
						} else if (foundProduct.unit === 'oz') {
							displayUnit = 'lbs';
							displayQty = availableQty / 16;
						}

						formattedItems.push({
							productName: foundProduct.productName || '-',
							variantName: foundVariant.displayName || foundVariant.name || '-',
							clientVariantId: foundVariant.clientVariantId || '-',
							qty: displayQty,
							unit: displayUnit,
						});
					} else {
						formattedItems.push({
							productName: prItem.productName || '-',
							variantName: '-',
							clientVariantId: '-',
							qty: prItem.qty,
							unit: prItem.unit || '-',
						});
					}
				});
				setItems(formattedItems);
			} catch (error) {
				console.error('Error fetching PR items:', error);
			} finally {
				setLoading(false);
			}
		};
		fetchItems();
	}, [pr.id, productsList]);

	if (loading) {
		return (
			<div className="flex items-center justify-center p-6 bg-gray-50 border-t border-gray-100">
				<Loader2 className="w-5 h-5 animate-spin text-gray-400" />
				<span className="ml-2 text-sm text-gray-400 font-medium">Loading items...</span>
			</div>
		);
	}

	return (
		<div className="p-4 px-16 bg-gray-50/50 border-t border-gray-200">
			<div className="overflow-hidden">
				<table className="w-full text-left border-collapse bg-transparent">
					<thead className="bg-transparent border-y border-gray-300">
						<tr>
							<th className="px-5 py-2.5 text-[11px] font-bold text-black uppercase tracking-wider w-16 text-left">Sno</th>
							<th className="px-5 py-2.5 text-[11px] font-bold text-black uppercase tracking-wider text-left">Item Name</th>
							<th className="px-5 py-2.5 text-[11px] font-bold text-black uppercase tracking-wider text-left">Sku Code</th>
							<th className="px-5 py-2.5 text-[11px] font-bold text-black uppercase tracking-wider text-left">Quantity</th>
						</tr>
					</thead>
					<tbody className="bg-transparent">
						{items.map((item, idx) => (
							<tr key={idx} className="hover:bg-blue-50/20 transition-colors bg-transparent">
								<td className="px-5 py-3 text-xs text-black font-semibold border-b border-gray-300 text-left">{idx + 1}</td>
								<td className="px-5 py-3 text-sm font-bold text-black border-b border-gray-300 text-left">
									{item.productName} <span className="text-gray-500 font-medium ml-1">({item.variantName})</span>
								</td>
								<td className="px-5 py-3 text-xs text-gray-500 font-medium border-b border-gray-300 text-left">{item.clientVariantId}</td>
								<td className="px-5 py-3 text-sm font-bold border-b border-gray-300 text-left">
									<span className="bg-blue-50 text-blue-700 px-3 py-1 rounded border border-blue-100 inline-flex items-center gap-1 shadow-sm">
										{item.qty} <span className="text-[10px] uppercase opacity-80 font-bold">{item.unit}</span>
									</span>
								</td>
							</tr>
						))}
						{items.length === 0 && (
							<tr>
								<td colSpan="4" className="px-5 py-10 text-center text-sm text-black italic border-b border-gray-300">
									No items found in this request.
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
};

const PRSelectionModalWrapper = ({
	storesList,
	usersList,
	initialStoreId,
	onUsePurchaseRequest,
	emptyMessage,
	renderSubRow,
}) => {
	const [prDataList, setPrDataList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [storeFilter, setStoreFilter] = useState(initialStoreId || '');
	const [dateRange, setDateRange] = useState([
		moment().subtract(10, 'days').toDate(),
		moment().toDate(),
	]);

	const fetchPRs = async (storeId, range) => {
		setLoading(true);
		try {
			const response = await purchaseRequestServices.fetchPurchaseRequestList({
				data: {
					filters: {
						storeId: storeId || null,
						dateRangeFilter: {
							from: range?.[0] ? moment(range[0]).format('YYYY-MM-DD') : null,
							to: range?.[1] ? moment(range[1]).format('YYYY-MM-DD') : null,
						},
						approvedActivePr : true
					}
				}
			});
			if (response?.statusCode === 200) {
				const approvedPrs = response?.data?.filter(ele => ele?.approvalStatus?.isFullyApproved) || [];
				setPrDataList(approvedPrs);
			}
		} catch (error) {
			console.error('Error fetching PRs:', error);
			notificationServices.generateNotification({
				type: 'error',
				message: 'Failed to fetch Purchase Requests',
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchPRs(storeFilter, dateRange);
	}, []);

	const handleSearch = () => {
		fetchPRs(storeFilter, dateRange);
	};

	return (
		<div style={{ padding: '16px' }}>
			<div
				className='flex gap-4 mb-4 items-center flex-wrap'
				style={{ marginBottom: '16px' }}
			>
				<div className='flex flex-col gap-1'>
					<label className='text-xs font-semibold text-gray-600'>Store</label>
					<SelectPicker
						data={storesList?.map(s => ({ label: s.name, value: s.id })) || []}
						value={storeFilter}
						onChange={setStoreFilter}
						style={{ width: 250 }}
						menuStyle={{ zIndex: 9999 }}
						placeholder="Select Store"
						cleanable
					/>
				</div>
				<div className='flex flex-col gap-1'>
					<label className='text-xs font-semibold text-gray-600'>Date Range</label>
					<DateRangePicker
						value={dateRange}
						onChange={setDateRange}
						style={{ width: 280 }}
						menuStyle={{ zIndex: 9999 }}
						format="dd/MM/yyyy"
						cleanable={false}
					/>
				</div>
				<Button
					onClick={handleSearch}
					className="mt-5 !bg-yellow-400 !text-black hover:!bg-yellow-500 shadow-sm flex items-center gap-2 h-[34px]"
					variant="contained"
				>
					<Search size={16} />
					Search
				</Button>
			</div>
			{loading ? (
				<div className='flex justify-center items-center h-[400px]'>
					<Loader size="md" content="Loading Purchase Requests..." vertical />
				</div>
			) : (
				<UniversalSelectionTable
					legend='Please select a single PR to proceed.'
					selectionType='single'
					dataList={prDataList}
					columns={[
						{ key: 'id', label: 'PR ID', width: 80 },
						{
							key: 'description',
							label: 'PR Name',
							width: 250,
							render: (pr) =>
								pr.jsonData?.description || '-',
						},
						{
							key: 'createdAt',
							label: 'Created At',
							width: 150,
							render: (pr) =>
								pr.createdAt
									? new Date(pr.createdAt).toLocaleDateString()
									: '-',
						},
						{
							key: 'approvedAt',
							label: 'Approved Date',
							width: 150,
							render: (pr) => {
								const lastLog =
									pr.approvalStatus?.logs?.[
									pr.approvalStatus?.logs?.length - 1
									];
								return lastLog?.createdAt
									? new Date(
										lastLog.createdAt
									).toLocaleDateString()
									: '-';
							},
						},
						{
							key: 'requestedBy',
							label: 'Requested By',
							width: 150,
							render: (pr) => {
								const user = usersList?.find(
									(u) => u.id === pr.requestedBy
								);
								return user
									? user.displayName : '-'
							},
						},
					]}
					showSubRow={true}
					renderSubRow={renderSubRow}
					emptyMessage={emptyMessage}
					actionButtons={[
						{
							label: 'Use Purchase Request',
							className:
								'!bg-yellow-400 !text-black hover:!bg-yellow-500 shadow-sm',
							disabled: (selectedItems) => !selectedItems,
							onClick: onUsePurchaseRequest,
						},
					]}
				/>
			)}
		</div>
	);
};

function CreatePurchaseOrder(props) {
	const {
		vendors,
		productsList,
		storesList,
		filteredStoresList,
		fetchProducts,
		// navState,
		fetchVendors,
		buyers,
		fetchStoresList,
		toggleAddVendorModal,
		toggleGenerateStandardPOModal,
		fetchProcessTypesList,
		processTypes,
		assetList,
		toggleFileUploaderModal,
		fetchAssetList,
		toggleAlert,
		toggleCustomModal,
		usersList,
		setUsersList,
	} = props;
	const query = useQuery();
	const history = useHistory();
	const location = useLocation();
	const { appConfig = {}, userConfig = {} } = useAuth();
	const { configs = {} } = appConfig || {};
	const { internalPOTypes = [], vendorContractItemFilter = false } = configs || {};
	const { dynamicPrice = false, P2PTransfer = false } =
		appConfig?.configs ?? {};
	const queryToStore = query.get('toStore');
	const queryByStore = query.get('fromStore');
	const queryStoreTypes = query.get('storeTypes');
	const queryUserOrderType = query.get('userOrderType');
	const poId = query.get('poId');
	const exclude = query.get('exclude');
	const editDraft = query.get('editDraft');

	const { parentStore, storeId } = userConfig?.store ?? {};

	const [defaultPoItems, setDefaultPoItems] = useState([]);
	const [productWiseMappingData, setProductWiseMappingData] = useState([]);
	const [processWiseMappingDataState, setProcessWiseMappingDataState] =
		useState([]);
	const [fromProcessStockProductIds, setFromProcessStockProductIds] =
		useState([]);
	const [variantIngPriceEnabledList, setVariantIngPriceEnabledList] =
		useState([]);
	const [internalProductionProductIds, setInternalProductionProductIds] =
		useState([]);
	const [selectedOrderType, setSelectedOrderType] = useState({});
	const orderTypeIdQuery = query.get('typeId') || selectedOrderType?.id;
	const isSpecLinked = query.get('specLinked') !== '0';
	const [processList, setProcessList] = useState([]);
	const isPrQuery = query.get('isPr') === 'true';
	const [productCategoriesList, setProductCategoriesList] = useState([]);
	const [skuTypeGroups, setSkuTypeGroups] = useState([]);

	// Vendor PO restricts the "Receiving Process" picker to STORAGE-type nodes
	// only. `processTypes` (Redux form state fetched via PROCESS_TYPES gateway
	// for the receiving store) is the unfiltered list. We derive a memoized
	// storage-only subset to drive visibility, mandatory marker, and validator.
	// Match BE convention: `node.data.type === 'STORAGE'`
	// (see Pages/ProcessFlowPage/CustomNode/ModernNode.js:172 etc.).
	const storageProcessTypes = useMemo(() => {
		if (!Array.isArray(processTypes)) return [];
		return processTypes.filter((node) => node?.data?.type === 'STORAGE');
	}, [processTypes]);

	const { CAN_ORDER_IN_PACKS, CAN_SUB_PACKAGE_ORDER } = useFeatureFlags();

	const customerId = appConfig?.customerId;

	// Sub-packaging work orders — item picker is restricted to the items
	// returned by CONVERSION_ELIGIBLE_ITEMS instead of the general catalogue.
	const [subPackagingItems, setSubPackagingItems] = useState([]);
	const [subPackagingItemsLoading, setSubPackagingItemsLoading] = useState(false);

	const { data: usersResponse } = useReactQuery({
		queryKey: ['usersList'],
		queryFn: () => userRolesAndPermissions.getUsersList(),
		staleTime: usersList?.length > 0 ? Infinity : 0,
		enabled: usersList?.length === 0,
	});

	useEffect(() => {
		if (usersResponse?.data?.length > 0) {
			setUsersList(usersResponse?.data);
		}
	}, [usersResponse]);

	const [state, dispatch] = useReducer(
		createOrderReducer(orderTypeIdQuery),
		editDraft
			? {
				...config?.initialState,
				...loadState(getStorageKey(orderTypeIdQuery)),
			}
			: {
				...config?.initialState,
			}
	);

	useEffect(() => {
		if (internalPOTypes?.length > 0 && selectedOrderType?.id === 2) {
			dispatch({
				type: 'SET_ORDER_TYPE_INTERNAL',
				payload: internalPOTypes[0],
			});
		} else {
			dispatch({ type: 'SET_ORDER_TYPE_INTERNAL', payload: 'PO' });
		}
	}, [selectedOrderType?.id]);

	useEffect(() => {
		if (editDraft) {
			dispatch({ type: 'RESTORE_UNSAVED_DATA' });
			return;
		}
	}, [editDraft]);

	useEffect(() => {
		if (orderTypeIdQuery !== '1') return;
		(async () => {
			try {
				const response = await inventoryAnalyticsServices.fetchGstCodes();
				if (response?.statusCode === 200) {
					const grouped = _.groupBy(response?.data, 'taxPercentage');
					setGroupedGstCodes(grouped);
				}
			} catch (error) {
				console.log('Error fetching GST codes:', error);
			}
		})();
	}, []);

	const [skuStockInfo, setSkuStockInfo] = useState([]);
	const [sendingStoreSkuPriceInfo, setSendingStoreSkuPriceInfo] = useState(
		{}
	);
	const [restrictedProducts, setRestrictedProducts] = useState({
		isRestrictedDeliverTo: [],
		isRestrictedFromStore: [],
	});
	const [rowError, setRowError] = useState({});
	const [asset, setAsset] = useState([]);
	const itemComponentRef = useRef(null);
	const [servicesList, setServices] = useState([]);
	const [assetsList, setAssetsList] = useState([]);
	const [shiftsList, setShiftsList] = useState([]);
	// eslint-disable-next-line no-unused-vars
	const [parentGroupedAssets, setParentGroupedAssets] = useState({});
	const [disableTerms, setDisableTerms] = useState(false);
	const [vendorPrices, setVendorPrices] = useState({});
	// Active contract of the selected vendor (from VendorContractProductsPricing)
	const [vendorContract, setVendorContract] = useState(null);
	// eslint-disable-next-line no-unused-vars
	const [isLoading, setIsLoading] = useState(false);
	const [doc, setDoc] = useState();
	// Existing PO-level document (order.jsonData.uploadedDoc) loaded on edit — lets the
	// edit-side mandatory check pass when a doc already exists and no new one is uploaded.
	const [existingDoc, setExistingDoc] = useState(null);
	const [dispatchDelta, setDispatchDelta] = useState();
	const [vendorFlag, setVendorFlag] = useState(false);
	const [groupedGstCodes, setGroupedGstCodes] = useState({});
	const [vendorOrgMappings, setVendorOrgMappings] = useState([]);
	const buyerSystemIdList = useRef([]);
	// PO-level defined charges (shown in POTotalContainer)
	const [definedAdditionalCharges, setDefinedAdditionalCharges] = useState([]);
	// ITEM-level defined charges (shown per row in POItemSelection)
	const [definedItemCharges, setDefinedItemCharges] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const response = await inventoryAnalyticsServices?.listAdditionalOrderCharges();
				if (response?.statusCode === 200 && response?.data) {
					const data = response?.data;
					let poCharges = [];
					let itemCharges = [];

					// Normalize the outer container to an array of groups so we
					// handle both a single { level, charges } object and an
					// array of them.
					const groups = Array.isArray(data) ? data : [data];
					const isLevelGrouped = groups?.some(
						(g) => g?.level && Array.isArray(g?.charges)
					);

					if (isLevelGrouped) {
						// Shape: [{ level:'ITEM', charges:[] }, { level:'PO', charges:[] }]
						groups.forEach((g) => {
							const lvl = String(g?.level).toUpperCase();
							if (lvl === 'ITEM') itemCharges = g?.charges ?? [];
							else if (lvl === 'PO') poCharges = g?.charges ?? [];
						});
					} else if (Array.isArray(data)) {
						// Legacy flat array of charge objects → treat as PO level.
						poCharges = data;
					} else if (typeof data === 'object') {
						// Shape keyed by level: { ITEM:[], PO:[] }
						itemCharges = data?.ITEM ?? data?.item ?? [];
						poCharges = data?.PO ?? data?.po ?? [];
					}

					setDefinedAdditionalCharges(poCharges);
					setDefinedItemCharges(itemCharges);
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log(error);
			}
		})();
	}, []);

	// Fetch vendor-organisation mappings when vendor changes (order type 1 only)
	useEffect(() => {
		if (state?.vendor?.id && Number(orderTypeIdQuery) === 1) {
			const fetchMappings = async () => {
				try {
					const res = await vendorOrganisationServices.listVendorMappings({
						data: { vendorId: state.vendor.id }
					});

					let mappings = [];
					if (res?.statusCode === 200) {
						mappings = (res.data ?? []).map((m) => ({
							...m,
							id: m.organisationId,
						}));

						// Fallback to all organisations if no specific mappings for this vendor
						if (mappings.length === 0) {
							const orgRes = await vendorOrganisationServices.listOrganisations({ data: {} });
							if (orgRes?.statusCode === 200) {
								mappings = orgRes.data ?? [];
							}
						}

						setVendorOrgMappings(mappings);

						// Auto-select if only 1 mapping/organisation present and none selected
						if (mappings.length === 1 && !state?.vendorOrganisationId) {
							dispatch({ type: 'SET_VENDOR_ORGANISATION_MAPPING', payload: mappings[0].id });
						}
					}
				} catch (error) {
					console.error('Error fetching mappings:', error);
					setVendorOrgMappings([]);
				}
			};

			fetchMappings();
		} else {
			setVendorOrgMappings([]);
		}
	}, [state?.vendor?.id, orderTypeIdQuery, state?.vendorOrganisationId]);

	const canPackFeatureFilterAllowed = CAN_ORDER_IN_PACKS;
	const canMakeSubPackageOrders = CAN_SUB_PACKAGE_ORDER;

	// Fetch the eligible-items list scoped to the selected store whenever the
	// operator is creating a SUB PACKAGING work order. Only these items may be
	// picked — the general product catalogue is not used for this mode.
	useEffect(() => {
		if (
			!(
				selectedOrderType?.id === 6 &&
				state?.workOrderType === 'SUB PACKAGING' &&
				canMakeSubPackageOrders
			)
		) {
			setSubPackagingItems([]);
			return;
		}
		if (!state?.store?.id) {
			setSubPackagingItems([]);
			return;
		}
		let isCurrent = true;
		(async () => {
			setSubPackagingItemsLoading(true);
			try {
				const response = await conversionServices.fetchEligibleItems({
					data: { storeId: state.store.id },
				});
				if (!isCurrent) return;
				const productsMap = new Map();
				(response?.data?.items ?? []).forEach((item) => {
					const productId = item?.productId;
					if (!productsMap.has(productId)) {
						productsMap.set(productId, {
							id: productId,
							productName: item?.productName,
							unit: item?.unit,
							variants: [],
						});
					}
					productsMap.get(productId).variants.push({
						id: item?.variantId,
						displayName: item?.variantName,
						unit: item?.unit,
						price: 0,
						source: item?.source,
						coInputs: item?.coInputs,
						packProcessId: item?.packProcessId,
					});
				});
				setSubPackagingItems([...productsMap.values()]);
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error('Error fetching sub-packaging eligible items:', error);
				if (isCurrent) setSubPackagingItems([]);
			} finally {
				if (isCurrent) setSubPackagingItemsLoading(false);
			}
		})();
		return () => {
			isCurrent = false;
		};
	}, [
		selectedOrderType?.id,
		state?.workOrderType,
		state?.store?.id,
		canMakeSubPackageOrders,
	]);

	const uploadInvoiceCick = () => {
		toggleFileUploaderModal(true, {
			heading: 'Upload Document',
			selectedFile: '',
			confirmText: 'Upload',
		});
	};

	const handleDocUpload = (fileData) => {
		setDoc(fileData);
		toggleFileUploaderModal(false);
	};

	const setPOItems = (newState) => {
		dispatch({
			type: 'SET_PO_ITEMS',
			payload:
				typeof newState === 'function'
					? newState(state?.poItems)
					: newState,
		});
	};

	useEffect(() => {
		if (selectedOrderType?.id === 1) {
			const diffInDays = moment(state?.expectedDeliveryDate)
				.startOf('day')
				.diff(moment(state?.date).startOf('day'), 'days');
			if (diffInDays > 365) {
				toggleAlert(true, {
					heading: '',
					message:
						'The expected delivery date is more than  1 Year from the order date. This will be considered a long-term Purchase Order',
					message2: 'Do you wish to continue ?',
					confirmText: 'Yes',
					cancelText: 'No',
					handleConfirm: () => {
						setVendorFlag(true);
						toggleAlert(false);
					},
				});
			}
		}
	}, [state?.expectedDeliveryDate, state?.date]);

	const updateManualRateUpdatedVariantIds = (idToAppend) => {
		dispatch({
			type: 'SET_MANUAL_RATE_UPDATED',
			payload: idToAppend,
		});
	};

	const setPOItemsObject = useCallback((newState) => {
		dispatch({
			type: 'SET_PO_ITEMS_OBJECT',
			payload: newState,
		});
	}, []);

	const setState = (type, value) => {
		if (type) {
			dispatch({
				type,
				payload: value,
			});
		}
	};

	useEffect(() => {
		setDispatchDelta(state?.fromStore?.dispatchedDaysDelta);
	}, [state]);

	useEffect(() => {
		if (
			queryToStore &&
			(queryToStore === 'undefined' || queryToStore === '-999')
		) {
			query.delete('toStore');
			history.replace({
				search: query.toString(),
				state: {
					prevPath: history?.location?.state?.prevPath,
				},
			});
		}
		if (
			queryByStore &&
			(queryByStore === 'undefined' || queryByStore === '-999')
		) {
			query.delete('fromStore');
			history.replace({
				search: query.toString(),
				state: {
					prevPath: history?.location?.state?.prevPath,
				},
			});
		}
		if (queryStoreTypes && queryStoreTypes === 'undefined') {
			query.delete('storeTypes');
			history.replace({
				search: query.toString(),
				state: {
					prevPath: history?.location?.state?.prevPath,
				},
			});
		}
	}, [queryToStore, queryByStore, queryStoreTypes]);

	const fetchShifts = useCallback(async () => {
		let processId = [];
		if (state?.orderTypeInternal !== 'CMS' && selectedOrderType?.id !== 2) {
			if (state?.transferOrderType !== 'DISPATCH') {
				processId = [state?.fromProcess?.id];
			} else {
				processId = [state?.toProcess?.id];
			}
		}
		if (state?.orderTypeInternal === 'CMS' && selectedOrderType?.id === 2) {
			processId = [state?.internalProcess?.id];
		}
		try {
			setIsLoading(true);
			const response = await shiftServices.listProcessShifts({
				data: {
					date: moment(state?.date).format('YYYY-MM-DD'),
					processIds: processId,
					store:
						state?.internalProcess?.id &&
							state?.orderTypeInternal === 'CMS'
							? state?.fromStore?.id
							: state?.store?.id,
				},
			});
			if (response?.statusCode === 200) {
				setShiftsList(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			notificationServices.generateNotification({
				type: 'error',
				message:
					'Api Failed Fetch shifts, please try again',
			});
			history.goBack();
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	}, [
		state?.store?.id,
		state?.date,
		state?.toProcess?.id,
		state?.fromProcess?.id,
		state?.transferOrderType,
		state?.internalProcess?.id,
	]);
	useEffect(() => {
		if (
			((selectedOrderType?.id === 5 || selectedOrderType?.id === 6) &&
				state?.toProcess?.id &&
				state?.date &&
				state?.store?.id &&
				(state?.transferOrderType || state?.workOrderType)) ||
			(state?.internalProcess?.id &&
				selectedOrderType?.id === 2 &&
				state?.orderTypeInternal === 'CMS')
		) {
			fetchShifts();
		}
	}, [
		selectedOrderType.id,
		state?.store?.id,
		state?.date,
		state?.toProcess?.id,
		fetchShifts,
		state?.fromProcess?.id,
		state?.transferOrderType,
		state?.workOrderType,
		state?.internalProcess?.id,
	]);
	useEffect(() => {
		if (
			poId &&
			(orderTypeIdQuery === '1' || orderTypeIdQuery === '8') &&
			vendors?.length > 0 &&
			storesList?.length > 0
		) {
			(async () => {
				try {
					const response = await inventoryAnalyticsServices.fetchPo(
						Number(poId)
					);
					if (response?.statusCode === 200) {
						setExistingDoc(response?.data?.jsonData?.uploadedDoc || null);
						let existingPoId = response?.data?.clientPoId;
						// if (response?.data?.clientPoId?.includes('PO-')) {
						// 	const splittedId =
						// 		response?.data?.clientPoId?.split('PO-');
						// 	existingPoId = splittedId?.[splittedId?.length - 1];
						// }
						const existingExpectedDelivery = moment(
							response?.data?.scheduledAt,
							'DD/MM/YYYY'
						)?.toDate();
						dispatch({
							// type: 'SET_VALUE_INIT',
							type: 'SET_VALUE_INIT',
							payload: {
								vendor: vendors?.find((ele) => {
									return ele?.id === response?.data?.vendorId;
								}),
								orderAmount: response?.data?.items?.reduce(
									(acc, curr) => {
										return acc + curr?.finalValue;
									},
									0
								),
								deliverTo: storesList?.find((ele) => {
									return ele?.id === response?.data?.storeId;
								}),
								fromStore: storesList?.find((ele) => {
									return (
										ele?.id === response?.data?.fromStore
									);
								}),
								purchaseOrderId: existingPoId,
								orderId: response?.data?.id,
								clientPOId: existingPoId,
								externalOrderRef:
									response?.data?.externalOrderRef,
								rejectionReason:
									response?.data?.jsonData?.rejectionReason,
								paymentTerm:
									response?.data?.jsonData?.paymentTerm,
								additionalCharges: response?.data?.jsonData
									?.additionalCharges ?? [
										{
											type: 'Additional Charges',
											price: 0,
											taxPercentage: 18,
										},
									],
								deliveryCharges:
									response?.data?.deliveryCharges ?? 0,
								packagingCharges:
									response?.data?.packagingCharges ?? 0,
								date: new Date(response?.data?.createdAt),
								expectedDeliveryDate: existingExpectedDelivery,
								vendorLocationId:
									response?.data?.vendorLocationId,
								vendorOrganisationId:
									response?.data?.vendorOrganisationId ??
									response?.data?.jsonData?.organisationMappingId ??
									response?.data?.jsonData?.vendorOrganisationId ??
									null,
								toProcess: response?.data?.toProcessId
									? { id: response?.data?.toProcessId }
									: null,
							},
						});
						const mappedItems = response?.data?.items?.map((item) => {
							return {
								...item,
								isTaxIncluded: item?.extraData?.isTaxIncluded,
								selectedGstCode: item?.extraData?.selectedGstCode,
								vendorSelection: item?.extraData?.vendorSelection,
								comment: item?.extraData?.comment ?? '',
								prId: response?.data?.prId,
							};
						});

						let finalMappedItems = [...mappedItems];
						if (response?.data?.prId) {
							const prDetail = await fetchSelectedPrDetailData(response?.data?.prId);
							if (prDetail?.items) {
								finalMappedItems = mappedItems.map((item) => {
									const prItem = prDetail.items.find(
										(pi) => Number(pi?.entityId) === Number(item?.variantId)
									);
									let prQuantity = null;
									if (prItem) {
										let prJsonData = prItem.jsonData;
										if (typeof prJsonData === 'string') {
											try {
												prJsonData = JSON.parse(prJsonData);
											} catch (e) {
												prJsonData = {};
											}
										}
										const availableQty = prJsonData?.availableQty || 0;

										const foundProduct = productsList.find((p) =>
											p.variants?.some(
												(v) => Number(v.id) === Number(prItem.entityId)
											)
										);

										let [displayAvailableQty] = getHigherUnitAndQuantity(
											foundProduct?.unit || prItem?.unit,
											availableQty
										);

										prQuantity = (item?.qty || 0) + displayAvailableQty;
									}

									return {
										...item,
										prQuantity: prQuantity,
									};
								});
							}
						}
						setDefaultPoItems(finalMappedItems);
						// if(editDraft){
						// 	dispatch({ type: 'RESTORE_UNSAVED_DATA' });
						// }
					}
				} catch (error) {
					notificationServices.generateNotification({
						type: 'error',
						message:
							'Api Failed (Fetch PO), please try again',
					});
					history.goBack();
					// eslint-disable-next-line no-console
					console.log(error);
				}
			})();
		}
	}, [
		poId,
		vendors?.length,
		storesList?.length,
		productsList?.length,
		orderTypeIdQuery,
	]);


	useEffect(() => {
		if (poId && orderTypeIdQuery === '9' && vendors?.length > 0) {
			(async () => {
				try {
					const response = await inventoryAnalyticsServices.fetchPo(
						Number(poId)
					);
					if (response?.statusCode === 200) {
						setExistingDoc(response?.data?.jsonData?.uploadedDoc || null);
						let existingPoId = response?.data?.clientPoId;
						// if (response?.data?.clientPoId?.includes('PO-')) {
						// 	const splittedId =
						// 		response?.data?.clientPoId?.split('PO-');
						// 	existingPoId = splittedId?.[splittedId?.length - 1];
						// }
						const existingExpectedDelivery = moment(
							response?.data?.scheduledAt,
							'DD/MM/YYYY'
						)?.toDate();

						dispatch({
							// type: 'SET_VALUE_INIT',
							type: 'SET_VALUE_INIT',
							payload: {
								vendor: vendors?.find((ele) => {
									return ele?.id === response?.data?.vendorId;
								}),
								orderAmount: response?.data?.items?.reduce(
									(acc, curr) => {
										return acc + curr?.finalValue;
									},
									0
								),
								deliverTo: storesList?.find((ele) => {
									return ele?.id === response?.data?.storeId;
								}),
								fromStore: storesList?.find((ele) => {
									return (
										ele?.id === response?.data?.fromStore
									);
								}),
								purchaseOrderId: existingPoId,
								orderId: response?.data?.id,
								clientPOId: existingPoId,
								externalOrderRef:
									response?.data?.externalOrderRef,
								rejectionReason:
									response?.data?.jsonData?.rejectionReason,
								paymentTerm:
									response?.data?.jsonData?.paymentTerm,
								additionalCharges: response?.data?.jsonData
									?.additionalCharges ?? [
										{
											type: 'Additional Charges',
											price: 0,
											taxPercentage: 18,
										},
									],
								deliveryCharges:
									response?.data?.deliveryCharges ?? 0,
								packagingCharges:
									response?.data?.packagingCharges ?? 0,
								date: new Date(response?.data?.createdAt),
								expectedDeliveryDate: existingExpectedDelivery,
								vendorLocationId:
									response?.data?.vendorLocationId,
								vendorOrganisationId:
									response?.data?.vendorOrganisationId ??
									response?.data?.jsonData?.organisationMappingId ??
									response?.data?.jsonData?.vendorOrganisationId ??
									null,
								toProcess: response?.data?.toProcessId
									? { id: response?.data?.toProcessId }
									: null,
							},
						});
						setDefaultPoItems(response?.data?.items);
						// if(editDraft){
						// 	dispatch({ type: 'RESTORE_UNSAVED_DATA' });
						// }
					}
				} catch (error) {
					notificationServices.generateNotification({
						type: 'error',
						message:
							'Api Failed (Fetch PO 2), please try again',
					});
					history.goBack();
					// eslint-disable-next-line no-console
					console.log(error);
				}
			})();
		}
	}, [poId, vendors, orderTypeIdQuery]);

	useEffect(() => {
		// eslint-disable-next-line no-restricted-globals
		if (orderTypeIdQuery && !isNaN(Number(orderTypeIdQuery))) {
			const orderType = orderTypes?.find((ele) => {
				return ele?.id === Number(orderTypeIdQuery);
			});
			setSelectedOrderType(orderType);
			// fetchPOId();
		}
	}, [orderTypeIdQuery]);

	useEffect(() => {
		if ([2, 3].includes(Number(orderTypeIdQuery)) || [2, 3].includes(selectedOrderType?.id)) {
			(async () => {
				try {
					const response = await skuTypeWiseGroupServices.listSkuTypeWiseGroups();
					if (response?.statusCode === 200 && response?.data) {
						setSkuTypeGroups(response.data);
						if (response.data.length > 0 && !state?.selectedSkuTypeGroup) {
							dispatch({
								type: 'SET_SKU_TYPE_WISE_GROUP',
								payload: response.data[0],
							});
						}
					}
				} catch (error) {
					console.error('Error fetching Sku Type Groups:', error);
				}
			})();
		}
	}, [orderTypeIdQuery, selectedOrderType?.id]);

	useEffect(() => {
		// eslint-disable-next-line no-restricted-globals
		if (
			(state?.deliverTo?.id ||
				state?.store?.id ||
				state?.fromStore?.id) &&
			selectedOrderType?.id !== 4
		) {
			const storeType = ['sales']?.includes(queryUserOrderType)
				? state?.fromStore?.id
				: state?.deliverTo?.id || state?.store?.id;
			if (storeType) {
				(async () => {
					// Vendor PO: once a Receiving Process is picked, show stock
					// available AT THAT PROCESS in the item picker instead of
					// store-wide stock. Falls back to store stock when no
					// process is selected (or for other order types).
					const processId =
						selectedOrderType?.id === 1
							? state?.toProcess?.id
							: null;
					const response = await inventoryAnalyticsServices.skuStock({
						params: {
							type: 'stock',
							storeId: storeType,
							...(processId ? { processId } : {}),
						},
					});
					const variantCurrentStockQtyMap = {};
					const variantTransferStockMap = {};
					Object.entries(response?.data)?.forEach(([, value]) => {
						value?.currentStock?.forEach((ele) => {
							variantCurrentStockQtyMap[ele?.variantId] =
								ele?.rawQty;
							variantTransferStockMap[ele?.variantId] =
								ele?.transferActive;
						});
					});
					const stockInfo = [
						{
							name: 'Available',
							bgColor: '#abc3',
							color: 'black',
							showInDropDown: true,
							columnIndexToShowIn: 0,
							values: variantCurrentStockQtyMap,
							transferValues: variantTransferStockMap,
						},
					];
					setSkuStockInfo(stockInfo);
				})();
			}
		}
	}, [
		state?.deliverTo?.id,
		state?.store?.id,
		state?.fromStore?.id,
		state?.toProcess?.id,
		selectedOrderType?.id,
	]);

	useEffect(() => {
		// eslint-disable-next-line no-restricted-globals
		const sourceStoreId = [5, 6].includes(selectedOrderType?.id)
			? state?.store?.id
			: state?.fromStore?.id;
		if (
			sourceStoreId &&
			(dynamicPrice ||
				['WAREHOUSE_INGREDIENT'].includes(state?.fromStore?.type) ||
				[2, 3, 5, 8].includes(selectedOrderType?.id))
		) {
			(async () => {
				try {
					const response = await inventoryAnalyticsServices.skuStock({
						params: {
							type: 'stock',
							storeId: sourceStoreId,
						},
					});
					if (response?.statusCode !== 200) {
						notificationServices.generateNotification({
							type: 'error',
							message:
								'Error fetching sku stock info, Please try again',
						});
						history.goBack();
					}
					const variantCurrentStockQtyMap = {};
					Object.entries(response?.data)?.forEach(([, value]) => {
						value?.currentStock?.forEach((ele) => {
							variantCurrentStockQtyMap[ele?.variantId] = ele;
						});
					});
					setSendingStoreSkuPriceInfo(variantCurrentStockQtyMap);
				} catch (error) {
					// eslint-disable-next-line no-console
					notificationServices.generateNotification({
						type: 'error',
						message:
							'Fetching sku stock info Error, Please try again',
					});
					history.goBack();
				}
			})();
		}
	}, [dynamicPrice, state?.fromStore?.id, state?.store?.id, selectedOrderType?.id]);

	// const raiseForWrongPrice = useCallback((product, variant) => {
	// 	if(['INTERMEDIATE', 'PRODUCT'].includes(product?.skuType)){
	// 		notificationServices.generateNotification({
	// 			type: 'error',
	// 			message: 'Unable to get mapping price for the product ' + product?.productName + ' (' + variant?.displayName + ')',
	// 		});
	// 		history.goBack();
	// 	}
	// }, []);

	const getVarPrice = useCallback(
		(product, variant) => {
			if (variantIngPriceEnabledList?.includes(product.id)) {
				return variant?.price;
			}
			if (
				dynamicPrice ||
				['WAREHOUSE_INGREDIENT'].includes(state?.fromStore?.type)
			) {
				let price = sendingStoreSkuPriceInfo?.[variant?.id]?.lastPrice;
				// if(dynamicPrice && !price && ['PRODUCT', 'INGREDIENT'].includes(product?.skuType)){
				// 	price=0;
				// 	return price;
				// 	// raiseForWrongPrice(product, variant);
				// }
				if (product?.unit === 'gram' || product?.unit === 'ml') {
					if (!price) {
						price = variant?.price || variant?.transferPrice;
					} else {
						price /= 1000;
					}
					return price;
				}
				if (!price) {
					return variant?.price || variant?.transferPrice;
				}
				return price;
			}
			return variant?.transferPrice ?? variant?.price;
		},
		[
			sendingStoreSkuPriceInfo,
			dynamicPrice,
			selectedOrderType?.id,
			state?.fromStore?.type,
			variantIngPriceEnabledList,
		]
	);

	const processWiseMappingData = async () => {
		if (selectedOrderType?.id === 5 && state?.store?.id) {
			const req = {
				data: {
					store: {
						id: state?.store?.id,
					},
					mappingTypes: [1],
					categoryId: null,
					products: null,
				},
			};
			try {
				const response =
					await productProcessMapServices?.fetchProductWiseMappingData(
						req
					);
				if (response?.responseCode === 'SS-001') {
					setProcessWiseMappingDataState(
						response?.data?.productwiseMappings
					);
					return response?.data?.productwiseMappings;
				}
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message:
						'Api Failed (5), please try again',
				});
				history.goBack();
			}
		}
	};

	useEffect(() => {
		if (selectedOrderType?.id === 5 && state?.store?.id) {
			processWiseMappingData();
		}
	}, [selectedOrderType?.id, state?.store?.id]);

	// Type 5 (customer 73 only): current-stock based product filtering is
	// disabled — all products are shown for customer 73 + order type 5.
	// useEffect(() => {
	// 	if (
	// 		Number(customerId) !== 73 ||
	// 		selectedOrderType?.id !== 5 ||
	// 		!state?.store?.id ||
	// 		!state?.toProcess?.id
	// 	) {
	// 		setFromProcessStockProductIds([]);
	// 		return;
	// 	}
	// 	(async () => {
	// 		try {
	// 			const response = await inventoryAnalyticsServices.skuStock({
	// 				params: {
	// 					type: 'stock',
	// 					storeId: state?.store?.id,
	// 					processId: state?.toProcess?.id,
	// 				},
	// 			});
	// 			const stockedIds = Object.values(response?.data || {})
	// 				.filter((sku) =>
	// 					sku?.currentStock?.some(
	// 						(vr) => Number(vr?.rawQty) > 0
	// 					)
	// 				)
	// 				.map((sku) => sku?.id)
	// 				.filter((id) => id != null);
	// 			setFromProcessStockProductIds(stockedIds);
	// 		} catch (error) {
	// 			// eslint-disable-next-line no-console
	// 			console.error('Error fetching from-process stock:', error);
	// 			setFromProcessStockProductIds([]);
	// 		}
	// 	})();
	// }, [selectedOrderType?.id, state?.store?.id, state?.toProcess?.id, customerId]);

	const PRODUCTS = useMemo(() => {
		if (state?.vendor?.isProduction) {
			return productsList;
		}
		// Customer 73 + order type 5: send the raw products list as-is.
		if ( [73, 71].includes(Number(customerId)) && selectedOrderType?.id === 5) {
			return productsList;
		}
		let prList;
		const restrictedProductIds = [
			...new Set([
				...restrictedProducts?.isRestrictedFromStore,
				...restrictedProducts?.isRestrictedDeliverTo,
			]),
		];
		prList = productsList?.filter((ele) => {
			if (selectedOrderType?.id === 2 || selectedOrderType?.id === 3) {
				if (
					restrictedProductIds?.length > 0 &&
					restrictedProductIds?.includes(ele?.id)
				) {
					return false;
				}
			}
			if (
				restrictedProducts?.isRestrictedDeliverTo?.length > 0 &&
				restrictedProducts?.isRestrictedDeliverTo?.includes(ele?.id)
			) {
				return false;
			}
			if (
				selectedOrderType?.id === 6 &&
				!ele?.isCookingEnabled &&
				state?.workOrderType === 'CMS'
			) {
				return false;
			}
			// Exclude COMBO products for Bakingo (customerId === 52) — they
			// aren't directly orderable as PO line items for this client,
			// except on a Base Kitchen PO (order type 2).
			if (
				customerId === 52
				&& selectedOrderType?.id !== 2
				&& String(ele?.productType).toUpperCase() === 'COMBO'
			) {
				return false;
			}
			return ele?.isEnabled !== false;
		});
		if (
			!(
				selectedOrderType?.id === 2 &&
				state?.fromStore?.type === 'RETAIL'
			)
		) {
			prList = prList?.filter((product) => {
				// Traded products are finished goods (skuType PRODUCT) that the
				// business buys from a vendor rather than producing in-house, so
				// allow them to be procured on a Vendor PO regardless of skuType.
				if (selectedOrderType?.enum === 'VENDOR' && product?.traded) {
					return true;
				}
				return selectedOrderType?.skuTypes?.includes(product?.skuType);
			});
		}
		if (state?.selectedSkuTypeGroup && [2, 3].includes(selectedOrderType?.id)) {
			const groupSkuTypes = state.selectedSkuTypeGroup.skuTypes?.map((t) => String(t).toUpperCase()) || [];
			prList = prList?.filter((product) => {
				// A traded product is a finished good that is bought in, so it belongs to
				// both the INGREDIENT and the PRODUCT groups.
				if (product?.traded && (groupSkuTypes.includes('INGREDIENT') || groupSkuTypes.includes('PRODUCT'))) {
					return true;
				}
				return groupSkuTypes.includes(String(product?.skuType).toUpperCase());
			});
		}
		if (![5, 6].includes(selectedOrderType?.id)) {
			prList = prList?.filter((product) => {
				if (internalProductionProductIds?.includes(product.id)) {
					return false;
				}
				return true;
			});
		}

		const transferValuesMap = skuStockInfo?.[0]?.transferValues || {};
		const shouldApplyTransferFilter = selectedOrderType?.id === 2;
		const shouldApplyContractFilter = vendorContractItemFilter === true && selectedOrderType?.id === 1;
		prList = prList
			?.map((product) => {
				const productVariants = product?.variants
					?.filter((vr) => {
						if (vr?.isDisabled === true) return false;
						if (
							shouldApplyTransferFilter
							&& vr?.id in transferValuesMap
							&& transferValuesMap[vr.id] === false
						) {
							return false;
						}
						if (
							shouldApplyContractFilter
							&& !(vr?.id in vendorPrices)
						) {
							return false;
						}
						return true;
					})
					.map((vr) => {
						let price = vr.price;
						if (selectedOrderType?.id !== 1) {
							price = getVarPrice(product, vr);
						}
						return {
							...vr,
							price,
						};
					});

				return {
					...product,
					originalUnit: product?.unit,
					unit:
						selectedOrderType?.id === 1
							? product?.purchaseUnit || product?.unit
							: product?.unit,
					variants: productVariants,
				};
			})
			?.filter((product) => product?.variants?.length > 0);

		// Customer 73 + type 5: no filtering — show the full product list.
		if (
			selectedOrderType?.id === 5 &&
			state?.toProcess?.id &&
			Number(customerId) !== 73
		) {
			if (
				processWiseMappingDataState &&
				processWiseMappingDataState.length > 0
			) {
				const mappedProductIds = processWiseMappingDataState
					.filter(
						(mapping) =>
							mapping?.mappingTypeElementValue ==
							state?.toProcess?.id
					)
					.map((mapping) => mapping?.productId);
				const allowedProductIds = [
					...new Set([
						...mappedProductIds,
						// current-stock based allowance disabled
						// ...fromProcessStockProductIds,
					]),
				];
				if (allowedProductIds.length > 0) {
					prList = prList?.filter((product) =>
						allowedProductIds.includes(product?.id)
					);
				}
			}
		}
		return prList || [];
	}, [
		productsList,
		selectedOrderType?.skuTypes,
		selectedOrderType?.id,
		internalProductionProductIds,
		state?.fromStore?.type,
		state?.deliverTo?.type,
		state?.vendor?.id,
		sendingStoreSkuPriceInfo,
		getVarPrice,
		restrictedProducts,
		state?.workOrderType,
		variantIngPriceEnabledList,
		processWiseMappingDataState,
		fromProcessStockProductIds,
		state?.toProcess?.id,
		vendorPrices,
		vendorContractItemFilter,
		customerId,
		skuStockInfo,
		state?.selectedSkuTypeGroup,
	]);

	const SKU_STOCK_INFO = useMemo(() => {
		if (PRODUCTS?.length > 0 && skuStockInfo?.length > 0) {
			const newObj = {};
			const productVarMap = {};
			PRODUCTS.forEach((prd) => {
				prd?.variants?.forEach((vr) => {
					productVarMap[vr.id] = vr;
				});
			});
			Object.entries(skuStockInfo?.[0]?.values).forEach(
				([key, amount]) => {
					if (productVarMap?.[key]?.factorPurchaseUnit) {
						newObj[key] = Math.round(
							amount /
							(productVarMap?.[key]?.factorPurchaseUnit || 1)
						);
					} else {
						newObj[key] = 0;
					}
				}
			);
			return [
				{
					...skuStockInfo[0],
					values: newObj,
				},
			];
		}
		return [];
	}, [PRODUCTS, skuStockInfo]);

	useEffect(() => {
		(async () => {
			try {
				const response =
					await productCategoryServcies.listProductCategory({
						req: { params: { id: '' } },
					});
				if (response?.statusCode === 200) {
					setProductCategoriesList(response?.data ?? []);
				}
			} catch (error) {
				console.error('Failed to fetch product categories', error);
			}
		})();
		fetchProducts({
			entity: 'ALL_PRODUCTS',
			req: {
				params: {
					id: '',
					variants: true,
				},
			},
			method: 'LIST',
		});
		fetchStoresList({
			entity: 'STORES',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		fetchStoresList({
			entity: 'FILTERED_STORES',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
	}, []);

	useEffect(() => {
		fetchVendors({
			entity: orderTypeIdQuery === '8' ? 'ALL_BUYERS' : 'ALL_VENDORS',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
			type: orderTypeIdQuery === '8' ? 'BUYER' : 'VENDOR',
		});
	}, [orderTypeIdQuery]);

	useEffect(async () => {
		if (state?.deliverTo?.id || state?.store?.id) {
			fetchProcessTypesList({
				entity: 'PROCESS_TYPES',
				req: {
					params: {
						id: '',
						storeId: state?.store?.id ?? state?.deliverTo?.id,
					},
				},
				method: 'LIST',
			});
		}
		if (
			['CMS', 'CMS_INDENT'].includes(state?.orderTypeInternal) &&
			state?.fromStore?.id
		) {
			try {
				const response = await processFlowServices.fetchNodes({
					params: {
						storeId: state?.fromStore?.id,
					},
				});
				if (response?.statusCode === 200) {
					setProcessList(response?.data?.nodes);
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log(error);
				notificationServices.generateNotification({
					type: 'error',
					message:
						'Api Failed (6), please try again',
				});
				history.goBack();
			}
		}
	}, [
		state?.deliverTo?.id,
		state?.store?.id,
		state?.fromStore?.id,
		state?.orderTypeInternal,
	]);

	useEffect(() => {
		if (!poId) return;
		if (orderTypeIdQuery !== '1') return;
		const toProcess = state?.toProcess;
		if (!toProcess?.id) return;
		if (toProcess?.data?.heading) return; // already resolved
		if (!Array.isArray(processTypes) || processTypes.length === 0) return;
		const fullNode = processTypes.find((n) => n?.id === toProcess.id);
		if (fullNode) {
			dispatch({ type: 'SET_TO_PROCESS', payload: fullNode });
		}
	}, [poId, orderTypeIdQuery, state?.toProcess?.id, processTypes]);

	// New vendor PO: pre-select the store's default receiving process (Edit Node -> "Default
	// receiving process"). Runs only when a freshly fetched list arrives, so a store switch
	// (which clears toProcess) never picks up the previous store's default, and a process the
	// user picked or cleared is left alone.
	useEffect(() => {
		if (poId || orderTypeIdQuery !== '1' || state?.toProcess?.id) return;
		const defaultNode = storageProcessTypes.find((node) => node?.data?.isDefault);
		if (defaultNode) {
			dispatch({ type: 'SET_TO_PROCESS', payload: defaultNode });
		}
	}, [storageProcessTypes]);

	useEffect(() => {
		if (['1', '4', '5', '6', '7', '8', '9'].includes(orderTypeIdQuery))
			return;
		if (state?.fromStore?.id) {
			const wareOrderType = orderTypes?.[2];
			const baseOrderType = orderTypes?.[1];
			switch (state?.fromStore?.type) {
				case 'WAREHOUSE_INGREDIENT':
					setSelectedOrderType(wareOrderType);
					break;
				default:
					setSelectedOrderType(baseOrderType);
					break;
			}
		}
	}, [state?.fromStore?.id, orderTypeIdQuery]);
	// eslint-disable-next-line no-unused-vars
	const handleVendorChangePrice = (poItem, itemPrice) => {
		// const itemPrice = mappedData?.[poItem?.id] ?? poItem?.selectedVariant?.price;
		const productQtyValue = poItem?.quantity;
		const productInputUnit = poItem?.productInputUnit;
		const subTotal = config.getSubTotal(
			itemPrice,
			0,
			productQtyValue,
			productInputUnit
		);
		const totalTax = config.getTotalTax(
			itemPrice,
			0,
			poItem?.tax,
			productQtyValue,
			productInputUnit
		);
		const totalDiscount = config.getTotalDiscount(
			itemPrice,
			0,
			productQtyValue,
			productInputUnit
		);
		const newItem = {
			...poItem,
			totalPriceIncTax: config.getTotalPrice(subTotal, totalTax),
			totalDiscount,
			disabledPrice: true,
		};
		newItem.selectedVariant.price = itemPrice;
		return newItem;
	};

	const fetchVendorProductPricing = useCallback(
		async (data) => {
			try {
				const response =
					await allVendorServices.VendorContractProductsPricing(data);
				if (response.statusCode === 200) {
					const priceData = response?.data?.prices;
					const contract = response?.data?.contract;
					const paymentTerm = contract?.paymentTerm;
					setVendorContract(contract?.id ? contract : null);
					if (paymentTerm) {
						setDisableTerms(true);
					} else {
						setDisableTerms(false);
					}
					// When the payment term is not coming from a contract, fall
					// back to the vendor's default payment term (paymentTermCode).
					// Create flow only (!poId), so a saved PO's payment term is
					// not overridden on edit.
					const effectivePaymentTerm =
						paymentTerm ||
						(!poId ? data?.vendorPaymentTermCode : undefined);
					// if (!priceData) {
					// 	const newState = getLatestPoItems?.map((poItem) => {
					// 		if (poItem?.disabledPrice) {
					// 			const variantSelected = poItem?.variants?.find(
					// 				(variant) => {
					// 					return (
					// 						variant?.id ===
					// 						poItem?.selectedVariant?.id
					// 					);
					// 				}
					// 			);
					// 			let itemPrice = variantSelected?.price;
					// 			if (
					// 				poItem?.unit === 'gram' ||
					// 				poItem?.unit === 'ml'
					// 			) {
					// 				itemPrice *= 1000;
					// 			}
					// 			if (poItem?.unit === 'oz') {
					// 				itemPrice *= 16;
					// 			}
					// 			if (poItem?.unit === 'floz') {
					// 				itemPrice *= 128;
					// 			}
					// 			const newItem = handleVendorChangePrice(
					// 				poItem,
					// 				itemPrice
					// 			);
					// 			const newItemDisabled = {
					// 				...newItem,
					// 				disabledPrice: false,
					// 			};
					// 			return newItemDisabled;
					// 		}
					// 		return poItem;
					// 	});
					// 	setState('SET_PO_ITEMS', newState);
					// }
					dispatch({
						type: 'SET_PAYMENT_TERM',
						payload: effectivePaymentTerm,
					});
					const mappedData = {};
					priceData.forEach((item) => {
						mappedData[item?.variantId] = item?.price;
					});
					setVendorPrices(mappedData);
					// const newState = getLatestPoItems?.map((poItem) => {
					// 	console.log('====', poItem);
					// 	if (poItem?.id in mappedData) {
					// 		let itemPrice =
					// 			mappedData?.[poItem?.id] ??
					// 			poItem?.selectedVariant?.price;
					// 		if (poItem?.unit === 'gram' || poItem?.unit === 'ml') {
					// 			itemPrice *= 1000;
					// 		}
					// 		if (poItem?.unit === 'oz') {
					// 			itemPrice *= 16;
					// 		}
					// 		if (poItem?.unit === 'floz') {
					// 			itemPrice *= 128;
					// 		}
					// 		return handleVendorChangePrice(poItem, itemPrice);
					// 	}
					// 	if (poItem?.disabledPrice) {
					// 		const variantSelected = poItem?.variants?.find(
					// 			(variant) => {
					// 				return (
					// 					variant?.id === poItem?.selectedVariant?.id
					// 				);
					// 			}
					// 		);
					// 		let itemPrice = variantSelected?.price;
					// 		if (poItem?.unit === 'gram' || poItem?.unit === 'ml') {
					// 			itemPrice *= 1000;
					// 		}
					// 		if (poItem?.unit === 'oz') {
					// 			itemPrice *= 16;
					// 		}
					// 		if (poItem?.unit === 'floz') {
					// 			itemPrice *= 128;
					// 		}
					// 		const newItem = handleVendorChangePrice(
					// 			poItem,
					// 			itemPrice
					// 		);
					// 		const newItemDisabled = {
					// 			...newItem,
					// 			disabledPrice: false,
					// 		};
					// 		return newItemDisabled;
					// 	}
					// 	return poItem;
					// });
					// setState('SET_PO_ITEMS', newState);
					notificationServices.generateNotification({
						type: 'success',
						message:
							response?.message ??
							'Vendor product pricing fetched successfully',
					});

				} else {
					setDisableTerms(false);
					setVendorPrices({});
					setVendorContract(null);
				}
			} catch (error) {
				setVendorContract(null);
				notificationServices.generateNotification({
					type: 'error',
					message:
						'Api Failed (1), please try again',
				});
				history.goBack();
				// eslint-disable-next-line no-console
				console.log(error);
			}
		},
		[state?.poItems]
	);

	useEffect(() => {
		if (
			(orderTypeIdQuery === '1' &&
				state?.vendor?.id &&
				state?.deliverTo?.id) ||
			(orderTypeIdQuery === '8' &&
				state?.vendor?.id &&
				state?.fromStore?.id)
		) {
			if (orderTypeIdQuery === '1') {
				fetchVendorProductPricing({
					vendorId: state?.vendor?.id,
					storeId: state?.deliverTo?.id,
					vendorPaymentTermCode: state?.vendor?.paymentTermCode,
				});
			} else {
				fetchVendorProductPricing({
					vendorId: state?.vendor?.id,
					storeId: state?.fromStore?.id,
					vendorPaymentTermCode: state?.vendor?.paymentTermCode,
				});
			}
		}
	}, [
		orderTypeIdQuery,
		state?.vendor?.id,
		state?.deliverTo?.id,
		state?.fromStore?.id,
	]);
	// useEffect(() => {
	// 	if (
	// 		orderTypeIdQuery === '8' &&
	// 		state?.vendor?.id &&
	// 		state?.fromStore?.id
	// 	) {
	// 		fetchVendorProductPricing({
	// 			vendorId: state?.vendor?.id,
	// 			storeId: state?.fromStore?.id,
	// 		});
	// 	}
	// }, [orderTypeIdQuery, state?.vendor?.id, state?.fromStore?.id]);

	async function fetchPOId() {
		if (poId) return;
		try {
			const response = await inventoryAnalyticsServices.fetchPOId();
			if (response?.statusCode === 200) {
				setState('SET_PURCHASE_ORDER', response?.data);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message:
					'Api Failed (7), please try again',
			});
			history.goBack();
			// eslint-disable-next-line no-console
			console.log(error);
		}
	}

	useEffect(() => {
		if ((state?.deliverTo?.id || state?.fromStore?.id) && selectedOrderType?.id === 1) {
			(async () => {
				const req = {
					data: {
						store: {
							id: state?.deliverTo?.id ?? state?.fromStore?.id,
						},
						mappingTypes: [6],
						categoryId: null,
						products: null,
					},
				};
				try {
					const response =
						await productProcessMapServices?.fetchProductWiseMappingData(
							req
						);
					if (response?.responseCode === 'SS-001') {
						// notificationServices.generateNotification({
						// 	type: 'success',
						// 	message: response?.responseMessage,
						// });
						setProductWiseMappingData(
							response?.data?.productwiseMappings
						);
					}
				} catch (error) {
					notificationServices.generateNotification({
						type: 'error',
						message:
							'Api Failed (8), please try again',
					});
					history.goBack();
					notificationServices.generateNotification({
						type: 'error',
						message: error?.message,
					});
				}
			})();
		}
	}, [state?.deliverTo?.id, state?.fromStore?.id]);

	useEffect(() => {
		if ([2, 3].includes(selectedOrderType?.id)) {
			(async () => {
				const req = {
					data: {
						store: {
							id: state?.fromStore?.id,
						},
						mappingTypes: [14],
						categoryId: null,
						products: null,
					},
				};
				try {
					const response =
						await productProcessMapServices?.fetchProductWiseMappingData(
							req
						);
					if (response?.responseCode === 'SS-001') {
						// notificationServices.generateNotification({
						// 	type: 'success',
						// 	message: response?.responseMessage,
						// });
						const variantIngPriceEnabledList = [];
						response?.data?.productwiseMappings?.forEach((ele) => {
							if (ele?.mappingTypeElementValue === '1') {
								variantIngPriceEnabledList.push(ele?.productId);
							}
						});
						setVariantIngPriceEnabledList(
							variantIngPriceEnabledList
						);
					}
				} catch (error) {
					notificationServices.generateNotification({
						type: 'error',
						message:
							'Api Failed (9), please try again',
					});
					history.goBack();
					notificationServices.generateNotification({
						type: 'error',
						message: error?.message,
					});
				}
			})();
		}
	}, [selectedOrderType?.id]);

	useEffect(() => {
		if (selectedOrderType?.id === 2) {
			(async () => {
				const req = {
					data: {
						store: {
							id: null,
						},
						mappingTypes: [12],
						categoryId: null,
						products: null,
					},
				};
				try {
					const response =
						await productProcessMapServices?.fetchProductWiseMappingData(
							req
						);
					if (response?.responseCode === 'SS-001') {
						// notificationServices.generateNotification({
						// 	type: 'success',
						// 	message: response?.responseMessage,
						// });
						const productIds = [];
						response?.data?.productwiseMappings?.forEach((ele) => {
							if (ele?.mappingTypeElementValue === '1') {
								productIds.push(ele?.productId);
							}
						});
						setInternalProductionProductIds(productIds);
					}
				} catch (error) {
					notificationServices.generateNotification({
						type: 'error',
						message:
							'Api Failed (10), please try again',
					});
					history.goBack();
					notificationServices.generateNotification({
						type: 'error',
						message: error?.message,
					});
				}
			})();
		}
	}, [selectedOrderType?.id]);

	useEffect(() => {
		if (
			selectedOrderType?.id !== 7 &&
			(state?.deliverTo?.id || state?.storeId?.id)
		) {
			(async () => {
				const req = {
					data: {
						store: {
							id: state?.deliverTo?.id ?? state?.storeId?.id,
						},
						// 13: Production at Outlets. 27: Items Not Orderable to Store - only for orders
						// that procure into this store (vendor / internal / transfer POs).
						mappingTypes: [1, 2, 3, 5].includes(selectedOrderType?.id) ? [13, 27] : [13],
						categoryId: null,
						products: null,
					},
				};
				try {
					const response =
						await productProcessMapServices?.fetchProductWiseMappingData(
							req
						);
					if (response?.responseCode === 'SS-001') {
						// notificationServices.generateNotification({
						// 	type: 'success',
						// 	message: response?.responseMessage,
						// });
						const productIds = [];
						response?.data?.productwiseMappings?.forEach((ele) => {
							if (ele?.mappingTypeElementValue === '1') {
								productIds.push(ele?.productId);
							}
						});
						setRestrictedProducts((prev) => ({
							...prev,
							isRestrictedDeliverTo: productIds,
						}));
					}
				} catch (error) {
					notificationServices.generateNotification({
						type: 'error',
						message:
							'Api Failed (11), please try again',
					});
					history.goBack();
					notificationServices.generateNotification({
						type: 'error',
						message: error?.message,
					});
				}
			})();
		}
	}, [state?.deliverTo?.id, selectedOrderType?.id]);

	useEffect(() => {
		if (
			selectedOrderType?.id !== 7 &&
			(selectedOrderType?.id === 3 || selectedOrderType?.id === 2) &&
			(state?.fromStore?.id || state?.storeId?.id)
		) {
			(async () => {
				const req = {
					data: {
						store: {
							id: state?.fromStore?.id ?? state?.storeId?.id,
						},
						// 13: Production at Outlets. 26: Items Not Orderable from Store (transfer out).
						mappingTypes: [13, 26],
						categoryId: null,
						products: null,
					},
				};
				try {
					const response =
						await productProcessMapServices?.fetchProductWiseMappingData(
							req
						);
					if (response?.responseCode === 'SS-001') {
						// notificationServices.generateNotification({
						// 	type: 'success',
						// 	message: response?.responseMessage,
						// });
						const productIds = [];
						response?.data?.productwiseMappings?.forEach((ele) => {
							if (ele?.mappingTypeElementValue === '1') {
								productIds.push(ele?.productId);
							}
						});
						setRestrictedProducts((prev) => ({
							...prev,
							isRestrictedFromStore: productIds,
						}));
					}
				} catch (error) {
					notificationServices.generateNotification({
						type: 'error',
						message:
							'Api Failed (12), please try again',
					});
					history.goBack();
					notificationServices.generateNotification({
						type: 'error',
						message: error?.message,
					});
				}
			})();
		}
	}, [selectedOrderType?.id, state?.fromStore?.id]);

	useEffect(() => {
		if (selectedOrderType?.id === 2 || selectedOrderType?.id === 3) {
			const store = storesList?.find((ele) => {
				return ele?.id === (Number(queryByStore) ?? parentStore);
			});
			if (store) {
				setState('SET_FROM_STORE_INIT', store);
			}
		}
		const deliverToStore = storesList?.find((ele) => {
			return ele?.id === (Number(queryToStore) ?? storeId);
		});
		if (deliverToStore) {
			setState('SET_DELIVER_TO_INIT', deliverToStore);
			// setState('SET_PROCESS', {});
		}
	}, [
		selectedOrderType?.id,
		storesList,
		parentStore,
		storeId,
		queryToStore,
		queryByStore,
	]);

	const fetchAssets = () => {
		fetchAssetList({
			req: {},
		});
	};

	const fetchServices = () => {
		// eslint-disable-next-line no-unused-vars
		const resp = assetServices.listCapexServiceType().then((result) => {
			setServices(result.data);
		});
	};

	useEffect(() => {
		if (
			selectedOrderType?.id === 4 ||
			selectedOrderType?.id === 7 ||
			selectedOrderType?.id === 9
		) {
			fetchAssets();
			if (selectedOrderType?.id !== 7) {
				fetchServices();
			}
		}
	}, [selectedOrderType?.id]);

	useEffect(() => {
		if (
			selectedOrderType?.id === 4 ||
			selectedOrderType?.id === 7 ||
			selectedOrderType?.id === 9
		) {
			const excludedAssetIds = [548, 6, 7, 19, 20];
			const useRecommendedPrice =
				selectedOrderType?.id === 7 && !isSpecLinked;
			const updatedAssetList = assetList
				?.filter((itm) => !excludedAssetIds.includes(itm?.id))
				?.map((itm) => {
					return {
						...itm,
						productName: itm.name,
						discountPercentage: 0,
						unit: 'count',
						productImageUrl: itm?.image,
						tax: itm?.taxPercentage,
						variants: [
							{
								id: itm?.id,
								displayName: 'ASSET',
								price: useRecommendedPrice
									? Number(itm?.recommendedPrice ?? 0)
									: 1,
							},
						],
					};
				});
			setAssetsList(updatedAssetList);
			let serviceList = [];
			if (selectedOrderType?.id === 9) {
				serviceList = servicesList?.map((itm) => {
					return {
						...itm,
						productName: itm.name,
						discountPercentage: 0,
						unit: 'count',
						tax: 18,
						variants: [
							{
								// eslint-disable-next-line prefer-template
								id: 's' + itm?.id,
								displayName: 'SERVICE',
								price: 1,
							},
						],
					};
				});
			}
			const concatList = [...updatedAssetList, ...serviceList];
			setAsset(concatList);
		}
	}, [selectedOrderType?.id, assetList, servicesList, isSpecLinked]);

	const taxApplied = useMemo(() => {
		const taxAppliedState = {
			isApplied: true,
			reason: '',
		};
		if (
			state?.vendor?.id &&
			state?.vendorLocation?.id &&
			!state?.vendorLocation?.gstin
		) {
			taxAppliedState.isApplied = true;
			taxAppliedState.reason = `GST will be split between CGST and SGST Due to Vendor (${state?.vendor?.name})'s GSTIN Absence`;
		}
		if (state?.deliverTo?.id && !state?.deliverTo?.gstNumber) {
			taxAppliedState.isApplied = false;
			taxAppliedState.reason = `GST Cannot Be Claimed Due to Deliver to Store (${state?.deliverTo?.name}) Unregistered GSTIN`;
		}
		if (state?.fromStore?.id && !state?.fromStore?.gstNumber) {
			taxAppliedState.isApplied = false;
			taxAppliedState.reason = `GST Cannot Be Claimed Due to Purchase From Store (${state?.fromStore?.name}) Unregistered GSTIN`;
		}
		return taxAppliedState;
	}, [
		state?.vendor,
		state?.vendorLocation?.id,
		state?.fromStore,
		state?.deliverTo,
	]);

	const calculatedData = useMemo(() => {
		let subTotal = 0;
		let totalTax = 0;
		let totalAmount = 0;
		let totalDiscount = 0;
		let freightVendorCost = 0;
		let itemLevelChargesTotal = 0;
		let taxValues = {};
		const totalQuantity = state?.poItems?.length;
		state?.poItems?.forEach?.((ele) => {
			// if (ele?.unit === 'gram') {
			subTotal += ele?.subTotal;
			totalAmount += ele?.totalPriceIncTax;
			totalTax += ele?.totalTax;
			totalDiscount += ele?.totalDiscount;
			if (orderTypeIdQuery === '1') {
				const rate = parseFloat(ele?.vendorSelection?.vendorRate) || 0;
				const qty = parseFloat(ele?.quantity) || 0;
				freightVendorCost += rate * qty;
			}
			(ele?.extraData?.additionalCharges ?? [])?.forEach((charge) => {
				itemLevelChargesTotal += Number(charge?.price) || 0;
			});
		});

		totalAmount += freightVendorCost;
		// Add item-level additional charges to the grand total
		totalAmount += itemLevelChargesTotal;

		const pc = Number(state?.packagingCharges ?? 0);
		const dc = Number(state?.deliveryCharges ?? 0);
		totalTax += ((pc + dc) * taxPercentage) / 100;
		totalAmount += (pc + dc) * (1 + taxPercentage / 100);
		if (state?.additionalCharges?.length) {
			state?.additionalCharges?.forEach((ele) => {
				totalTax += Number(ele?.price * ele?.taxPercentage) / 100;
				totalAmount +=
					Number(ele?.price) * Number(1 + ele?.taxPercentage / 100);
			});
		}
		if (taxApplied?.isApplied) {
			taxValues.SGST = totalTax / 2;
			taxValues.CGST = totalTax / 2;
			if (state?.vendor?.id) {
				// Buyer SO: our fromStore is the seller; PO: our deliverTo store is the receiver
				const storeGstNumber =
					orderTypeIdQuery === '8'
						? state?.fromStore?.gstNumber
						: state?.deliverTo?.gstNumber;
				if (state?.vendor?.gstin && storeGstNumber) {
					const vendorState = getStateFromGSTIN(state?.vendor?.gstin);
					const storeState = getStateFromGSTIN(storeGstNumber);
					if (
						vendorState !== storeState &&
						vendorState !== 'Unknown'
					) {
						taxValues = {
							IGST: totalTax,
						};
					}
				}
			} else {
				const fromStoreState = getStateFromGSTIN(
					state?.fromStore?.gstNumber
				);
				const toStoreState = getStateFromGSTIN(
					state?.deliverTo?.gstNumber
				);
				if (fromStoreState !== toStoreState) {
					taxValues = {
						IGST: totalTax,
					};
				}
			}
		}
		return {
			subTotal,
			totalQuantity,
			totalTax,
			totalAmount,
			taxValues,
			totalDiscount,
			freightVendorCost,
			itemLevelChargesTotal,
		};
	}, [
		state?.poItems,
		state?.vendor?.id,
		state?.vendor?.gstin,
		state?.deliverTo?.gstNumber,
		state?.fromStore?.gstNumber,
		state?.packagingCharges,
		state?.deliveryCharges,
		state?.additionalCharges,
		orderTypeIdQuery,
	]);
	const isRowError = useCallback(() => {
		const isAssetOrder = [4, 7, 9].includes(selectedOrderType?.id);
		const varMap = {};
		state?.poItems?.forEach((ele, index) => {
			const variantId = ele?.selectedVariant?.id;
			if (varMap[variantId]) {
				varMap[variantId].rowNumbers.push(index + 1);
			} else {
				varMap[variantId] = { ...ele, rowNumbers: [index + 1] };
			}
		});
		let result = false;
		Object?.entries(rowError)?.forEach(([eleKey, ele]) => {
			Object?.keys(ele ?? {})?.forEach((innerEleKey) => {
				if (ele?.[innerEleKey] === true) {
					const element = varMap[eleKey];
					if (!element || !element?.productName) {
						return;
					}
					const rowNumbers = element?.rowNumbers ?? [];
					const rowStr =
						isAssetOrder && rowNumbers?.length
							? `at S.No: ${rowNumbers?.join(', ')} `
							: '';
					const str = `${rowStr}for variantId: ${eleKey}, Name: ${element?.productName} (${element?.selectedVariant?.displayName})`;
					if (innerEleKey === 'rate') {
						notificationServices.generateNotification({
							type: 'error',
							message: `Please enter valid Rate ${str}`,
						});
					}
					if (innerEleKey === 'quantity') {
						notificationServices.generateNotification({
							type: 'error',
							message: `Please enter valid Quantity ${str}`,
						});
					}
					result = true;
				}
			});
		});
		return result;
	}, [rowError, state?.poItems, selectedOrderType?.id]);

	const handleSave = async (itemsOverride) => {
		// When called directly from the Save button, React passes a SyntheticEvent
		// as the first argument.  Ignore anything that isn't a plain array so the
		// event object is never mistaken for an items override.
		const validItemsOverride = Array.isArray(itemsOverride) ? itemsOverride : undefined;
		if ([2, 3].includes(selectedOrderType?.id) && skuTypeGroups?.length > 0 && !state?.selectedSkuTypeGroup) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Sku Type Group is mandatory',
			});
			return;
		}
		if (
			selectedOrderType?.id !== 6 ||
			!['PACKAGING', 'SUB PACKAGING'].includes(state.workOrderType)
		) {
			if (isRowError()) {
				return;
			}
		}
		const [validationError, focusIndex] = config?.validator(
			state,
			orderTypeIdQuery ?? selectedOrderType?.id,
			processList,
			shiftsList,
			vendorOrgMappings,
			storageProcessTypes,
			isSpecLinked,
			processTypes
		);
		if (validationError?.length > 0) {
			validationError?.forEach((err) => {
				notificationServices.generateNotification({
					type: 'error',
					message: err,
				});
			});
			if (focusIndex !== -1) {
				const children = itemComponentRef?.current?.children;
				if (children && children?.length > 0) {
					children[focusIndex].scrollIntoView({
						behavior: 'smooth',
						block: 'center',
					});
				}
			}
			return;
		}

		// ── Buyer SO: handle items with empty quantity ──────────────────────────
		// When the user loaded all contract items, some may still have quantity = null.
		// If at least one item has a valid qty we offer to skip the empty ones;
		// if NONE have a valid qty we block submission entirely.
		if (selectedOrderType?.id === 8 && !validItemsOverride) {
			const emptyQtyItems = (state?.poItems ?? []).filter(
				(item) => !item?.quantity || Number(item?.quantity) <= 0
			);
			const validQtyItems = (state?.poItems ?? []).filter(
				(item) => item?.quantity && Number(item?.quantity) > 0
			);

			if (emptyQtyItems.length > 0) {
				if (validQtyItems.length === 0) {
					// No item has a valid quantity — cannot submit
					notificationServices.generateNotification({
						type: 'error',
						message: 'At least one item must have a valid quantity before saving.',
					});
					return;
				}

				// Some items have qty, some don't — ask the user to confirm

				toggleAlert(true, {
					heading: 'Items with Missing Quantity',
					message: (
						<div style={{ fontSize: '14px', lineHeight: '1.6' }}>
							<p style={{ marginBottom: '8px' }}>
								The following <strong>{emptyQtyItems.length}</strong> item(s) have no quantity and will be <strong>ignored</strong>:
							</p>
							<ul style={{ listStyle: 'disc', paddingLeft: '18px', marginBottom: '8px', maxHeight: '200px', overflowY: 'auto' }}>
								{emptyQtyItems.map((item, idx) => (
									<li key={idx} style={{ marginBottom: '4px' }}>
										{item?.productName ?? 'Unknown item'}
										{item?.selectedVariant?.displayName || item?.selectedVariant?.name
											? ` (${item?.selectedVariant?.displayName ?? item?.selectedVariant?.name})`
											: ''}
									</li>
								))}
							</ul>
							<p>
								Do you want to skip these items and save the order with the remaining <strong>{validQtyItems.length}</strong> item(s)?
							</p>
						</div>
					),
					confirmText: 'Yes, Skip & Save',
					cancelText: 'Go Back',
					colorReverse: true,
					handleConfirm: () => {
						toggleAlert(false);
						// Pass valid items directly — avoids stale-closure issues
						// with a state-update + setTimeout approach.
						handleSave(validQtyItems);
					},
					handleCancel: () => {
						toggleAlert(false);
					},
					width: '32rem',
				});
				// Stop here — will re-enter handleSave with itemsOverride after confirm
				return;
			}
		}
		// ───────────────────────────────────────────────────────────────────────
		const currentDate = moment().startOf('day')?.toDate();
		if (
			currentDate > state?.expectedDeliveryDate &&
			selectedOrderType?.id !== 5
		) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Past Delivery Date not allowed',
			});
			return;
		}
		// console.log('parentGroupedAssets', parentGroupedAssets);
		// console.log('state', state);
		// if (selectedOrderType?.id === 7) return;
		const deserializedData = config?.deserialize(
			validItemsOverride ? { ...state, poItems: validItemsOverride } : state,
			selectedOrderType?.id,
			parentGroupedAssets,
			buyerSystemIdList?.current,
			isSpecLinked
		);
		const req = {
			data: {
				...deserializedData,
				taxValues: calculatedData?.taxValues,
				type: selectedOrderType?.enum,
				taxOnDelivery: taxPercentage,
				taxOnPackaging: taxPercentage,
				nextFlowLink: `${window?.location?.origin}${urls.EXTENSION}${urls.VENDOR_ORDER_LIST}`,
			},
		};
		// Vendor order (id === 1) config-gated mandatory fields, mirroring the backend
		// Business_Config.configs gates (vendorPoAttachmentMandatory / vendorPoPrMandatory).
		if (selectedOrderType?.id === 1) {
			if (configs?.vendorPoAttachmentMandatory && !doc) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'A supporting document is mandatory for Vendor Purchase Orders.',
				});
				return;
			}
			if (configs?.vendorPoPrMandatory && !req.data.prId) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'A Purchase Request must be selected for Vendor Purchase Orders.',
				});
				return;
			}
		}
		setIsLoading(true);
		try {
			// Sub-packaging work orders go through the dedicated conversion
			// work-order endpoint instead of the generic placeOrder call —
			// toProcess/fromProcess are intentionally omitted so the backend
			// derives them from the items' packing mapping.
			if (
				selectedOrderType?.id === 6 &&
				state?.workOrderType === 'SUB PACKAGING'
			) {
				const items = state?.poItems?.map((ele) => {
					const itemQty =
						ele?.productInputUnit !== 'count'
							? Number(
								getUnitConvertedQuantity(
									Number(ele?.quantity),
									ele?.productInputUnit,
									false,
									true
								)
							)
							: Number(ele?.quantity);
					return {
						variantId: ele?.selectedVariant?.id ?? null,
						qty: !isNaN(itemQty) ? itemQty : null,
					};
				});
				const response = await conversionServices.createConversionWorkOrder({
					data: {
						storeId: state?.store?.id,
						items,
						date: moment(state?.date)?.format('MM/DD/YYYY'),
						shift: state?.selectedShift?.id ?? null,
					},
				});
				if (response?.statusCode === 200) {
					notificationServices.generateNotification({
						type: 'success',
						message: response?.message,
						config: {
							duration: 10000,
						},
					});
					fetchPOId();
					if (orderTypeIdQuery) {
						history.replace(history?.location?.state?.prevPath, {
							prevPath: location?.pathname,
						});
					}
					dispatch({
						type: 'SAVE_SUCCESS',
					});
				}
				return;
			}
			if (selectedOrderType?.id === 8) {
				req.data.store = state?.fromStore?.id;
				req.data.uploadedDoc = doc;
			}
			if (selectedOrderType?.id === 1) {
				req.data.flag = vendorFlag;
				if (doc) {
					req.data.uploadedDoc = doc;
				}
			}
			// Machine transfer -> create a CMS_INDENT order. The backend maps
			// appOrderType 'CMS_INDENT' to type CMS / subType CMS_INDENT, and the
			// selected transfer items become the order's ingredients (items).
			if (
				selectedOrderType?.id === 5 &&
				state?.transferUsing === 'Machine'
			) {
				req.data.type = 'CMS';
				req.data.appOrderType = 'CMS_INDENT';
			}
			const response = await inventoryAnalyticsServices?.addVendorPO(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
					config: {
						duration: 10000,
					},
				});
				fetchPOId();
				if (orderTypeIdQuery) {
					history.replace(history?.location?.state?.prevPath, {
						prevPath: location?.pathname,
					});
				}
				dispatch({
					type: 'SAVE_SUCCESS',
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};
	const handleEditSave = async () => {
		if ([2, 3].includes(selectedOrderType?.id) && skuTypeGroups?.length > 0 && !state?.selectedSkuTypeGroup) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Sku Type Group is mandatory',
			});
			return;
		}
		const validationError = config?.validator(
			state,
			selectedOrderType?.id ?? orderTypeIdQuery,
			processList,
			shiftsList,
			vendorOrgMappings,
			storageProcessTypes,
			isSpecLinked,
			processTypes
		);
		if (validationError?.[0]?.length > 0) {
			validationError?.[0]?.forEach((err) => {
				notificationServices.generateNotification({
					type: 'error',
					message: err,
				});
			});
			return;
		}
		const currentDate = moment().startOf('day')?.toDate();
		if (currentDate > state?.expectedDeliveryDate) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Past Delivery Date not allowed',
			});
			return;
		}
		const deserializedData = config?.deserialize(
			state,
			selectedOrderType?.id,
			undefined,
			undefined,
			isSpecLinked
		);
		const req = {
			params: {
				poId,
			},
			data: {
				...deserializedData,
				taxValues: calculatedData?.taxValues,
				type: selectedOrderType?.enum,
				nextFlowLink: `${window?.location?.origin}${urls.EXTENSION}${urls.VENDOR_ORDER_LIST}`,
			},
		};
		// Vendor order (id === 1) edit: attachment stays mandatory when configured, mirroring the
		// backend editOrder gate. Passes if a doc already exists on the order OR a new one is uploaded.
		// (PR selection is create-only, so it's not enforced here.)
		if (
			selectedOrderType?.id === 1 &&
			configs?.vendorPoAttachmentMandatory &&
			!doc &&
			!existingDoc
		) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'A supporting document is mandatory for Vendor Purchase Orders.',
			});
			return;
		}
		try {
			if (selectedOrderType?.id === 1) {
				req.data.flag = vendorFlag;
				if (doc) {
					req.data.uploadedDoc = doc;
				}
			}
			// Machine transfer -> edit as a CMS_INDENT order (see handleSave).
			if (
				selectedOrderType?.id === 5 &&
				state?.transferUsing === 'Machine'
			) {
				req.data.type = 'CMS';
				req.data.appOrderType = 'CMS_INDENT';
			}
			const response = await inventoryAnalyticsServices?.editVendorPO(
				req,
				Number(orderTypeIdQuery)
			);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				dispatch({
					type: 'INIT',
				});
				if (orderTypeIdQuery) {
					history.goBack();
				}
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handleGenerateStandardPO = async () => {
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'loading...',
		});
		const req = {
			params: {
				store: state?.deliverTo?.id,
				...state?.fromStore?.id && {
					fromStore: state?.fromStore?.id,
				},
				...(state?.vendor?.id && {
					vendorId: state?.vendor?.id,
				}),
				orderType: state?.orderTypeInternal,
				...(state?.internalShift?.shiftName && {
					shiftName: state?.internalShift?.shiftName,
				}),
			},
		};
		try {
			const response = await inventoryAnalyticsServices.fetchStandardPO(
				req
			);
			if (response?.statusCode === 200) {
				const validVariantIds = new Set();
				PRODUCTS.forEach((product) => {
					product.variants?.forEach((variant) => {
						validVariantIds.add(variant.id);
					});
				});

				const filteredStandardPOData = response?.data?.filter((item) => {
					return validVariantIds.has(item.variantId);
				});

				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
					config: {
						id: notificationId,
					}
				});
				toggleGenerateStandardPOModal(true, {
					standardPOData: filteredStandardPOData?.map?.((item) => {
						return {
							...item,
							recommendedOrderQty: getUnitConvertedQuantity(
								item?.recommendedOrderQty,
								item?.unit,
								undefined,
								undefined,
								true
							),
							avgOrderQty: getUnitConvertedQuantity(
								item?.avgOrderQty,
								item?.unit,
								undefined,
								undefined,
								true
							),
							currentStock: getUnitConvertedQuantity(
								item?.currentStock,
								item?.unit,
								undefined,
								undefined,
								true
							),
							threshold: getUnitConvertedQuantity(
								item?.threshold,
								item?.unit,
								undefined,
								undefined,
								true
							),
							pendingOrderQty: getUnitConvertedQuantity(
								item?.pendingOrderQty,
								item?.unit,
								undefined,
								undefined,
								true
							),
							prePlanStock: getUnitConvertedQuantity(
								item?.prePlanStock,
								item?.unit,
								undefined,
								undefined,
								true
							),
							moq: getUnitConvertedQuantity(
								item?.moq,
								item?.unit,
								undefined,
								undefined,
								true
							),
							unit: getUnitConvertedUnit(
								undefined,
								item?.unit,
								true
							),
						};
					}),
					shiftName: state?.internalShift?.shiftName,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message,
					config: {
						id: notificationId,
					}
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message:
					'Api Failed (13), please try again',
				config: {
					id: notificationId,
				}
			});
			history.goBack();
			// eslint-disable-next-line no-console
			console.log('Error', error);
		}
	};

	const handleSelectOrderType = (e) => {
		const orderType = orderTypes?.find((ele) => {
			return ele?.id === Number(e?.target?.value);
		});
		setSelectedOrderType(orderType);

		// Update the URL with typeId
		const url = new URL(window.location);
		url.searchParams.set('typeId', orderType?.id);
		// `specLinked` only means anything for Asset Transfer Orders; drop it so it cannot leak
		// onto another order type.
		if (orderType?.id !== 7) {
			url.searchParams.delete('specLinked');
		}
		window.history.pushState({}, '', url); // Use replaceState if you don't want a new entry in browser history

		dispatch({
			type: 'INIT',
			payload: {},
		});
		fetchPOId();
		// dispatch({
		// type: 'SET_FROM_STORE',
		// payload: {},
		// });
		// setPOItems([]);
	};

	// const STORES_LIST = useMemo(() => {
	// 	if (selectedOrderType?.enum === 'PURCHASEORDER') {
	// 		return storesList;
	// 	}
	// 	return storesList;
	// }, [selectedOrderType?.enum, storesList]);

	const handleAdditionalCharges = (idx, e) => {
		// console.log('=============', idx, e);
		const { fieldName, fieldValue } = inputHelper(e);
		const newAdditionalCharge = state?.additionalCharges?.map(
			(ele, index) => {
				if (index === idx) {
					if (fieldName === 'chargeId') {
						const selected = definedAdditionalCharges?.find(
							(c) => Number(c?.id) === Number(fieldValue)
						);
						return {
							...ele,
							chargeId: selected?.id ?? null,
							chargeCode: selected?.chargeCode ?? null,
							type: selected?.chargeName ?? ele?.type,
						};
					}
					return {
						...ele,
						[fieldName]: fieldValue,
					};
				}
				return ele;
			}
		);
		if (editDraft) {
			dispatch({
				type: 'SET_VALUE_INIT',
				payload: {
					additionalCharges: newAdditionalCharge,
				},
			});
		} else {
			dispatch({
				type: 'SET_VALUE',
				payload: {
					additionalCharges: newAdditionalCharge,
				},
			});
		}
	};
	const addAdditonalCharges = () => {
		const newAdditionalCharge = [...state?.additionalCharges];
		newAdditionalCharge?.push({
			// eslint-disable-next-line prefer-template
			type: 'Charges ' + newAdditionalCharge?.length,
			taxPercentage: null,
			price: null,
		});
		if (editDraft) {
			dispatch({
				type: 'SET_VALUE',
				payload: {
					additionalCharges: newAdditionalCharge,
				},
			});
		} else {
			dispatch({
				type: 'SET_VALUE_INIT',
				payload: {
					additionalCharges: newAdditionalCharge,
				},
			});
		}
	};

	const handleRemoveAdditionalCharge = (idx) => {
		const newAdditionalCharge = [...state?.additionalCharges];
		newAdditionalCharge?.splice(idx, 1);
		dispatch({
			type: 'SET_VALUE',
			payload: {
				additionalCharges: newAdditionalCharge,
			},
		});
	};

	const DEFAULT_ITEMS_STATE = useMemo(() => {
		return defaultPoItems?.map((poItem) => {
			// console.log('====', poItem);
			if (poItem?.variantId in vendorPrices) {
				let variantVendorPrice = vendorPrices?.[poItem?.variantId];
				const higherUnits = ['kg', 'ltr', 'lb', 'gal'];
				if (higherUnits?.includes(poItem?.unit)) {
					if (['kg', 'ltr']?.includes(poItem?.unit)) {
						variantVendorPrice *= 1000;
					}
					if (poItem?.unit === 'lb') {
						variantVendorPrice *= 16;
					}
					if (poItem?.unit === 'gal') {
						variantVendorPrice *= 128;
					}
				}
				return {
					...poItem,
					variantVendorPrice,
					disabledPrice: true,
				};
			}
			return {
				...poItem,
				disabledPrice: false,
			};

			// if (poItem?.disabledPrice) {
			// 	const newItemDisabled = {
			// 		...poItem,
			// 		disabledPrice: false,
			// 	};
			// 	return newItemDisabled;
			// }
		});
	}, [defaultPoItems, vendorPrices]);

	// orderType 2 (Purchase From Store): if Purchase From Store and Deliver
	// To have the same GSTIN, the transfer is intra-entity — no tax applies.
	// Used to hide tax columns in the items table AND skip tax in the total
	// container (POTotalContainer).
	const hideTaxForIntraEntity = useMemo(() => {
		if (orderTypeIdQuery !== '2') return false;
		const fromGst = state?.fromStore?.gstNumber?.trim()?.toUpperCase();
		const toGst = state?.deliverTo?.gstNumber?.trim()?.toUpperCase();
		return !!(fromGst && toGst && fromGst === toGst);
	}, [orderTypeIdQuery, state?.fromStore?.gstNumber, state?.deliverTo?.gstNumber]);

	// filtercolumns logic here
	const filterColumns = useMemo(() => {
		// orderType 2 (Purchase From Store): if Purchase From Store and Store
		// have the same GSTIN, the transfer is intra-entity — no tax applies,
		// so hide the tax columns from the items table.
		if (orderTypeIdQuery == 2) {
			const fromGst = state?.fromStore?.gstNumber?.trim()?.toUpperCase();
			const toGst = state?.deliverTo?.gstNumber?.trim()?.toUpperCase();
			if (fromGst && toGst && fromGst === toGst) {
				return ['TAX %', 'Total Tax'];
			}
		}
		if (hideTaxForIntraEntity) {
			return ['TAX %', 'Total Tax'];
		}
		if ([5, 6]?.includes(selectedOrderType?.id)) {
			return [
				'EXPECTED LEFT OVER',
				'TAX %',
				'Total Discount',
				'Discount%',
				'RATE',

				'QTY-INFO',
				'Total Amount',
				'Sub total',
				'Total Tax',
			];
		}
		if (selectedOrderType?.id === 4 || selectedOrderType?.id === 7) {
			return [
				'EXPECTED LEFT OVER',
				'Total Discount',
				'Discount%',
				'UNIT',
			];
		}
		return undefined;
	}, [hideTaxForIntraEntity, orderTypeIdQuery, state?.fromStore, state?.deliverTo]);

	const onAssetGroupSelect = useCallback(
		(callback, groupKey, delta, newValue) => {
			setPOItemsObject(newValue);
			callback();
		},
		[setPOItemsObject]
	);

	const getTypeFromOrderTypeId = () => {
		const orderId = selectedOrderType?.id?.toString();
		switch (orderId) {
			case '8':
				return 'BUYER';
			case '9':
				return 'SERVICE';
			default:
				return 'VENDOR';
		}
	};

	const fetchBuyerProductMap = useCallback(async () => {
		try {
			const response = await allVendorServices?.buyerProductMap(
				{
					params: {
						vendor: state?.vendor?.id,
					},
				},
				'GET'
			);
			if (response?.statusCode == 200) {
				const data = response?.data;
				buyerSystemIdList.current = data;
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message:
					'Api Failed (14), please try again',
			});
			history.goBack();
			console.log(error);
		}
	}, [state?.vendor?.id]);

	const isLatLongSameForPOStore = useMemo(() => {
		return (
			state?.fromStore?.latitude === state?.deliverTo?.latitude &&
			state?.fromStore?.longitude === state?.deliverTo?.longitude
		);
	}, [
		state?.fromStore?.latitude,
		state?.fromStore?.longitude,
		state?.deliverTo?.latitude,
		state?.deliverTo?.longitude,
	]);

	useEffect(() => {
		if (state?.vendor?.id && selectedOrderType?.id === 8) {
			fetchBuyerProductMap();
		}
	}, [state?.vendor?.id]);


	const renderPRItemsAccordion = (pr) => {
		return <PRItemsList pr={pr} productsList={productsList} />;
	};

	const handlePurchaseRequest = async () => {
		toggleCustomModal(true, {
			header: 'Select Purchase Request',
			width: '1000px',
			height: 'auto',
			bodyClass: 'p-0',
			bodyContent: (
				<PRSelectionModalWrapper
					storesList={storesList}
					usersList={usersList}
					initialStoreId={state?.deliverTo?.id}
					renderSubRow={renderPRItemsAccordion}
					emptyMessage="No approved Purchase Requests found."
					onUsePurchaseRequest={async (selectedPR) => {
						toggleCustomModal(false);
						if (selectedPR?.id) {
							const prDetail = await fetchSelectedPrDetailData(selectedPR?.id);
							const prItems = prDetail?.items || [];
							const newPOItems = [];

							prItems.forEach((prItem) => {
								const foundProduct = productsList.find((p) =>
									p.variants?.some(
										(v) => Number(v.id) === Number(prItem.entityId)
									)
								);
								const foundVariant = foundProduct?.variants?.find(
									(v) => Number(v.id) === Number(prItem.entityId)
								);

								if (foundProduct && foundVariant) {
									let prJsonData = prItem.jsonData;
									if (typeof prJsonData === 'string') {
										try {
											prJsonData = JSON.parse(prJsonData);
										} catch (e) {
											prJsonData = {};
										}
									}
									const availableQty =
										prJsonData?.availableQty

									let itemPrice =
										vendorPrices?.[foundVariant.id] ??
										foundVariant.price;

									if (
										foundProduct.unit === 'gram' ||
										foundProduct.unit === 'ml'
									) {
										itemPrice *= 1000;
									}
									if (foundProduct.unit === 'oz') {
										itemPrice *= 16;
									}
									if (foundProduct.unit === 'floz') {
										itemPrice *= 128;
									}

									let displayUnit = foundProduct.unit;
									let displayQty = availableQty;
									if (foundProduct.unit === 'gram') {
										displayUnit = 'kg';
										displayQty = availableQty / 1000;
									} else if (
										foundProduct.unit === 'ml' ||
										foundProduct.unit === 'litre'
									) {
										displayUnit = 'ltr';
										displayQty = availableQty / 1000;
									} else if (foundProduct.unit === 'oz') {
										displayUnit = 'lbs';
										displayQty = availableQty / 16;
									}

									const subTotal = config.getSubTotal(
										itemPrice,
										0,
										displayQty,
										displayUnit
									);
									let totalTax = 0;
									if (taxApplied?.isApplied) {
										totalTax = config.getTotalTax(
											itemPrice,
											0,
											foundVariant.tax ?? foundProduct.tax ?? 0,
											displayQty,
											displayUnit
										);
									}
									const totalDiscount = config.getTotalDiscount(
										itemPrice,
										0,
										displayQty,
										displayUnit
									);

									const itemTax = foundVariant.tax ?? foundProduct.tax ?? 0;
									const applicableGst = groupedGstCodes[Number(itemTax)] || [];
									const defaultGstCode = applicableGst.length === 1 ? applicableGst[0].id : null;

									newPOItems.push({
										id: foundVariant.id,
										disabledPrice: !!vendorPrices?.[foundVariant.id],
										productId: foundProduct.id,
										productName: foundProduct.productName,
										serviceId: foundProduct.serviceId,
										assetId: foundProduct.assetId,
										productImageUrl: foundProduct.productImageUrl,
										variants: foundProduct.variants,
										quantity: displayQty,
										prQuantity: displayQty,
										unit: foundProduct.unit,
										selectedVariant: {
											...foundVariant,
											price: itemPrice,
										},
										discountPercentage: 0,
										skuType: foundProduct.skuType,
										tax: itemTax,
										subTotal,
										totalTax,
										totalDiscount,
										totalPriceIncTax:
											config.getTotalPrice(subTotal, totalTax),
										productInputUnit: displayUnit,
										salesConsumptionUnit: foundProduct.salesConsumptionUnit,
										assetCategory: foundProduct.assetCategory,
										sacCode: foundProduct.sacCode,
										existingItemId: null,
										prId: prDetail.id,
										comment: prJsonData?.remarks || '',
										selectedGstCode: defaultGstCode,
										isTaxIncluded: true,
										vendorSelection: {
											selectedVendorId: null,
											vendorRate: null,
										}
									});
								} else {

									const displayName = prItem.productName
										? `${prItem.productName} (${prItem.variantName})`
										: prItem.variantName || 'Unknown Product';

									notificationServices.generateNotification({
										type: 'error',
										message: `Product '${displayName}' from the PR is missing in your current Order Product list. This usually means the mapping is incorrect in 'Production at Outlets'. Please check the mapping or remove this product from the PR if it's no longer required.`,
									});
								}
							});
							setPOItems(newPOItems);
						}
					}}
				/>
			),
		});
	};

	const handleClearPOItems = () => {
		toggleAlert(true, {
			header: 'Clear PO Items',
			message: 'Are you sure you want to clear all Items?',
			confirmText: 'Clear',
			cancelText: 'Cancel',
			handleConfirm: () => {
				setPOItems([]);
				toggleAlert(false);
			},
		});
	}

	return (
		<div className={styles.root}>
			<CustomModal />
			<AlertModal />
			<FileUploaderModal handleConfirm={handleDocUpload} />
			<BackdropLoader isLoading={isLoading} showProgress />
			<AddNewVendorModal />
			<GenerateStandardPo
				poState={state?.poItems}
				getVarPrice={getVarPrice}
				setPoState={setPOItems}
			/>
			<ErrorModal />
			<CreatePurchaseOrderHeader
				showSave
				selectedOrderType={selectedOrderType}
				setSelectedOrderType={setSelectedOrderType}
				handleSave={poId ? handleEditSave : handleSave}
				isEdit={!!poId}
				disableSave={(selectedOrderType?.id !== 7 || !isSpecLinked) ? !state?.poItems?.length : !state?.poItemsObject}
				prevPath={history?.location?.state?.prevPath}
			/>
			<div className={styles['order-type']}>
				<label>Order Type:</label>
				{orderTypeIdQuery ? (
					<p>{selectedOrderType?.name}</p>
				) : (
					<div className={styles['selector-container']}>
						<TextField
							id='orderType'
							select
							value={selectedOrderType?.id ?? -1}
							onChange={handleSelectOrderType}
							label='Select Order Type'
							sx={{
								width: 300,
								'.MuiInputBase-root': {
									borderRadius: '4px',
								},
								'.MuiInputBase-input': {
									paddingTop: '6px',
									paddingBottom: '6px',
								},
							}}
						>
							{orderTypes
								?.filter((ele) => {
									if (exclude) {
										return ele?.id !== Number(exclude);
									}
									return true;
								})
								?.map((orderType) => {
									return (
										<MenuItem
											key={orderType?.id}
											value={orderType?.id}
										>
											{orderType?.name}
										</MenuItem>
									);
								})}
						</TextField>
						{!selectedOrderType?.id && (
							<p className={styles['warning-text']}>
								Select Order Type First
							</p>
						)}
					</div>
				)}
			</div>
			{selectedOrderType?.id && (
				<div className={styles.body}>
					<POGeneralDetails
						dispatchDelta={dispatchDelta}
						state={state}
						skuTypeGroups={skuTypeGroups}
						selectedSkuTypeGroup={state?.selectedSkuTypeGroup}
						setSelectedSkuTypeGroup={(val) => dispatch({ type: 'SET_SKU_TYPE_WISE_GROUP', payload: val })}
						disableMsg={
							poId
								? 'Please clear items to edit fields again'
								: state?.poItems?.length > 0 &&
									selectedOrderType?.id !== 5
									? 'Please clear items to edit fields again'
									: false
						}
						internalPOTypes={internalPOTypes}
						shiftsList={shiftsList}
						vendors={orderTypeIdQuery === '8' ? buyers : vendors}
						filteredStoresList={filteredStoresList}
						setState={setState}
						P2PTransfer={P2PTransfer}
						requiredFields={selectedOrderType?.fields}
						toggleAddVendorModal={toggleAddVendorModal}
						processList={processTypes}
						storageProcessTypes={storageProcessTypes}
						isDeliverToDisabled={!!queryToStore}
						queryUserOrderType={queryUserOrderType}
						queryStoreTypes={queryStoreTypes}
						orderType={selectedOrderType?.id}
						mandatoryFields={{
							...(selectedOrderType?.id === 5 && {
								fromProcess: true,
								toProcess: true,
							}),
							vendorLocation:
								!!state?.vendor?.vendor_locations?.length,
							...(selectedOrderType?.id === 2 && {
								// Delivery Location (deliverTo-side process) is mandatory
								// for CMS_INDENT sub-orders, OR — mirroring the Vendor PO
								// "Receiving Process" rule below — whenever the deliverTo
								// store has any process configured at all, regardless of
								// orderTypeInternal. Kept in sync with the validator's
								// `deliverToProcessTypes` check in CreatePurchaseOrder.config.js.
								cmsIndent:
									state?.orderTypeInternal === 'CMS_INDENT' ||
									(Array.isArray(processTypes) &&
										processTypes.length > 0),
							}),
							// Vendor PO: "Receiving Process" becomes mandatory only when
							// the deliverTo store is BASE-type AND has STORAGE-type
							// processes configured. Mirrors the BE rule at
							// purchase_order.py:11155 (createOrderObj). The list
							// shown is `storageProcessTypes` (memoized filter of
							// `processTypes` for `data.type === 'STORAGE'`).
							...(selectedOrderType?.id === 1 &&
								state?.deliverTo?.id &&
								state?.deliverTo?.type === 'BASE' &&
								storageProcessTypes.length > 0 && {
								toProcess: true,
							}),
						}}
						processFromStoreList={processList}
						disbalePaymentTerm={disableTerms}
						isEdit={!!poId}
						type={getTypeFromOrderTypeId()}
						uploadInvoiceCick={uploadInvoiceCick}
						doc={doc}
						docMandatory={selectedOrderType?.id === 1 && !!configs?.vendorPoAttachmentMandatory}
						filterLabels={{
							store: 'Store',
							processTypes: 'Process',
						}}
						disableAll={orderTypeIdQuery === '9' && !!poId}
						canMakePackOrders={canPackFeatureFilterAllowed}
						canMakeSubPackageOrders={canMakeSubPackageOrders}
						clientId={customerId}
						vendorOrgMappings={vendorOrgMappings}
						productCategoriesList={productCategoriesList}
						topInfo={
							vendorContract?.id && state?.vendor?.id ? (
								<div className='flex-1 min-w-[280px] flex items-center gap-2.5 bg-blue-50 border border-blue-100 rounded-lg py-2 px-3.5 shadow-sm'>
									<FileCheck2
										size={16}
										className='text-blue-500 flex-shrink-0'
									/>
									<p className='flex-1 text-blue-900 text-[13px] m-0 text-left leading-snug'>
										<span className='font-semibold'>
											{vendorContract?.vendorName || state?.vendor?.name}
										</span>
										{' '}
										has an active contract
										{vendorContract?.expiryDate && (
											<span className='text-blue-600'>
												{' · valid till '}
												{moment(new Date(vendorContract.expiryDate)).format('DD MMM YYYY')}
											</span>
										)}
									</p>
									<button
										type='button'
										onClick={() => {
											window.open(
												`${urls.EXTENSION}${urls.VENDOR_CONTRACT_CREATE}?isEdit=True&contractId=${vendorContract.id}&type=VENDOR`,
												'_blank'
											);
										}}
										className='flex-shrink-0 inline-flex items-center gap-1.5 bg-white text-blue-700 text-[12px] font-semibold border border-blue-200 rounded-md px-3 py-1.5 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-colors whitespace-nowrap'
									>
										View Contract
										<ExternalLink size={12} />
									</button>
								</div>
							) : null
						}
					/>
					{(selectedOrderType?.id !== 7 || !isSpecLinked) ? (
						<>
							<POItemSelection
								dispatchDelta={dispatchDelta}
								parentState={state}
								state={state?.poItems}
								setState={setPOItems}
								fromStore={state?.fromStore}
								deliverTo={state?.deliverTo}
								// Buyer SO from a BASE store: "Assembled At Outlet" boxes are
								// assembled there, so their contents can be changed per order.
								// A Buyer SO picks its store in From Store (it has no Deliver To).
								boxContentsEnabled={
									selectedOrderType?.id === 8 &&
									state?.fromStore?.type === 'BASE'
								}
								skuStockInfo={
									selectedOrderType.id === 4 ||
										selectedOrderType.id === 7 ||
										selectedOrderType.id === 9
										? []
										: SKU_STOCK_INFO
								}
								packSizedOrder={
									selectedOrderType.id === 6 &&
									state.workOrderType === 'PACKAGING' &&
									canPackFeatureFilterAllowed
								}
								showExtraRow={selectedOrderType?.id === 1 && state?.poItems?.length > 0 ? !state?.poItems?.every((item) => item?.prId) : true}
								taxApplied={taxApplied}
								productsList={
									selectedOrderType.id === 4 ||
										selectedOrderType.id === 7 ||
										selectedOrderType.id === 9
										? asset
										: selectedOrderType.id === 6 &&
											state.workOrderType === 'SUB PACKAGING'
											? subPackagingItems
											: selectedOrderType.id === 6 &&
												state.workOrderType === 'PACKAGING'
												? PRODUCTS?.filter((product) =>
													product?.variants?.some(
														(variant) =>
															variant?.packSizeConfig &&
															variant?.packSizeConfig
																?.length > 0
													)
												)
												: selectedOrderType?.id === 1 &&
													isPrQuery
													? productsList
													: PRODUCTS
								}
								servicesList={servicesList}
								assetsList={assetsList}
								assetList={''}
								productWiseMappingData={productWiseMappingData}
								requiredFields={selectedOrderType?.fields}
								typeId={selectedOrderType?.id}
								updateManualRateUpdatedVariantIds={
									updateManualRateUpdatedVariantIds
								}
								handleGenerateStandardPO={
									handleGenerateStandardPO
								}
								rowError={rowError}
								ratePerString={
									selectedOrderType.id === 2 ? 'Transfer' : ''
								}
								canOrderInPacks={
									canPackFeatureFilterAllowed &&
									((selectedOrderType.id === 2 &&
										!isLatLongSameForPOStore) ||
										(selectedOrderType.id === 8 &&
											(customerId === 72 || customerId === 5)))
								}
								ref={itemComponentRef}
								setRowError={setRowError}
								defaultSelectedItems={
									poId ? DEFAULT_ITEMS_STATE : null
								}
								disabled={
									(() => {
										if (!selectedOrderType?.id) return true;
										if (
											selectedOrderType?.id === 6 &&
											state?.workOrderType === 'SUB PACKAGING' &&
											subPackagingItemsLoading
										) {
											return true;
										}
										const [errors] = config.validator(state, selectedOrderType?.id, processList, shiftsList, vendorOrgMappings, [], isSpecLinked, processTypes);
										const generalErrors = errors?.filter(
											(err) =>
												err !== 'PO Items are mandatory' &&
												err !== 'Asset Items are mandatory' &&
												!err.includes('CoreSpecifications') &&
												!err.includes('Field is mandatory for') &&
												!err.includes('Quantity of Item')
										);
										return generalErrors?.length > 0;
									})()
								}
								qtyRegex={
									selectedOrderType?.id === 4 ||
										selectedOrderType?.id === 7 ||
										selectedOrderType?.id === 9
										? /^\+?(0|[1-9]\d*)?$/
										: null
								}
								filterColumns={filterColumns}
								vendorPrices={vendorPrices}
								handlePurchaseRequest={handlePurchaseRequest}
								prMandatory={selectedOrderType?.id === 1 && !!configs?.vendorPoPrMandatory}
								handleClearPOItems={handleClearPOItems}
								vendors={vendors}
								groupedGstCodes={groupedGstCodes}
								definedItemCharges={definedItemCharges}
								vendorContract={vendorContract}
							/>
							{![5, 6]?.includes(selectedOrderType?.id) && (
								<POTotalContainer
									calculatedData={calculatedData}
									packagingCharges={state?.packagingCharges}
									deliveryCharges={state?.deliveryCharges}
									handleChange={setState}
									showCharges
									taxPercentage={taxPercentage}
									disableCharges={false}
									additionalCharges={state?.additionalCharges}
									handleAdditionalCharges={
										handleAdditionalCharges
									}
									addAdditonalCharges={addAdditonalCharges}
									handleRemoveAdditionalCharge={
										handleRemoveAdditionalCharge
									}
									showAdditionalCharge={
										additinalDiv?.includes(selectedOrderType?.id) &&
										(definedAdditionalCharges?.length > 0 ||
											definedItemCharges?.length > 0
											? definedAdditionalCharges?.length > 0
											: true)
									}
									definedAdditionalCharges={definedAdditionalCharges}
									itemLevelChargesTotal={calculatedData?.itemLevelChargesTotal}
									hideTax={hideTaxForIntraEntity}
								/>
							)}
						</>
					) : (
						<>
							<div className='w-full'>
								<AssetListing
									heightSubtraction={200}
									selectedStoreId={state?.fromStore?.id}
									avoidTrackingChildAssets
									onAssetGroupSelect={onAssetGroupSelect}
									setParentGroupedAssets={
										setParentGroupedAssets
									}
								/>
							</div>
						</>
					)}
				</div>
			)}
		</div>
	);
}

const mapStateToProps = (state) => {
	const { LIST: productsList } = state.form.ALL_PRODUCTS.data;
	const { LIST: vendors } = state.form.ALL_VENDORS.data;
	const { LIST: buyers } = state.form.ALL_BUYERS.data;
	const { LIST: storesList } = state?.form?.STORES?.data;
	const { LIST: filteredStoresList } = state?.form?.FILTERED_STORES?.data;
	const { navState } = state?.navigation;
	const { LIST: processTypes } = state?.form?.PROCESS_TYPES?.data;
	const assetList = state.assets.list;
	const usersList = state.wastage?.usersList || [];

	return {
		productsList,
		vendors,
		buyers,
		storesList,
		filteredStoresList,
		navState,
		processTypes,
		assetList,
		usersList,
	};
};

const mapDispatchToProps = {
	fetchProducts: formActions.gateway,
	fetchVendors: formActions.gateway,
	fetchStoresList: formActions.gateway,
	toggleAddVendorModal: modalActions.toggleAddVendorModal,
	toggleGenerateStandardPOModal: modalActions.toggleGenerateStandardPOModal,
	fetchProcessTypesList: formActions.gateway,
	fetchAssetList: assetActions.fetchAssetList,
	toggleFileUploaderModal: modalActions.toggleFileUploaderModal,
	toggleAlert: modalActions.toggleAlert,
	toggleCustomModal: modalActions.toggleCustomModal,
	setUsersList: wastageAction.setUsersList,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CreatePurchaseOrder);
